(function () {
  /* =====================================
     COMMERCIAL EPOXY KIT BUILDER
     Works ONLY on /products/commercial-epoxy-flooring-systems
     (and the cart page for locking/bundle management)
  ===================================== */

  if (!window.fetch) {
    console.warn('Fetch not supported');
    return;
  }

  // =====================================
  // PAGE SCOPE GUARD — COMMERCIAL ONLY
  // =====================================
  const PATH = window.location.pathname.replace(/\/$/, '');

  const IS_BUILDER_PAGE =
    PATH.startsWith('/products/commercial-epoxy-flooring-systems');

  const IS_CART_PAGE =
    PATH === '/cart' ||
    document.body.classList.contains('template-cart') ||
    document.querySelector('.qsc2-drawer');

  if (!IS_BUILDER_PAGE && !IS_CART_PAGE) return;

  if (window.__COMMERCIAL_KIT_INITIALIZED__) return;
  window.__COMMERCIAL_KIT_INITIALIZED__ = true;

  console.log('✅ Commercial Epoxy Kit Builder loaded');

  window.__METALLIC_KIT_STATE__ = {
    sqft: null,
    sqftPrice: 0,
    toolkit: null,
    toolkitPrice: 0,
    epoxyColor: null,
    epoxyVariantId: null,
    upgrades: {},
    mvbSelection: null,
    topCoatSelection: null,
    topCoatTouched: false,
    appItems: {},
    easyMVBSelected: false,
    odorBlockSelected: false
  };

  /* =====================================
     CONFIG – VARIANT IDS
  ===================================== */

  const BUNDLE_VARIANTS = {
    400:   58048086343983,
    800:   58048086409519,
    1200:  58048086442287,
    1600:  58048086475055,
    2000:  58048086507823,
    2400:  58048086540591,
    2800:  58048086573359,
    3200:  58048086606127,
    3600:  58048086638895,
    4000:  58048086671663,
    4400:  58048086704431,
    4800:  58048086737199,
    5200:  58048086769967,
    5600:  58048086802735,
    6000:  58048086835503,
    6400:  58048086868271,
    6800:  58048086901039,
    7200:  58048086933807,
    7600:  58048086966575,
    8000:  58048086999343,
    8400:  58048087589167,
    8800:  58048087621935,
    9200:  58048087654703,
    9600:  58048087687471,
    10000: 58048087720239
  };

  const CONFIG = {
    epoxyColors: {
      white:       53501871259951,
      lite_gray:   53501871227183,
      royal_blue:  53501871194415,
      black:       53501871292719,
      medium_gray: 53501871358255,
      tan:         53501871325487
    }
  };

  /* =====================================
     COLOR PREVIEW BAR (800 × 130)
     Shows a solid-color preview above the
     base-color swatch row when a swatch
     is selected.
  ===================================== */

  const EPOXY_COLOR_HEX = {
    white:       '#ffffff',
    lite_gray:   '#c0c0c0',
    royal_blue:  '#00499f',
    black:       '#000000',
    medium_gray: '#797a79',
    tan:         '#e9c4a6'
  };

  function initColorPreviewBar() {
    const swatchContainer = document.querySelector('.vb-swatches');
    if (!swatchContainer) return;
    if (document.getElementById('commercial-color-preview-bar')) return;

    // Inject styles once
    if (!document.getElementById('commercial-preview-bar-style')) {
      const s = document.createElement('style');
      s.id = 'commercial-preview-bar-style';
      s.textContent = `
        #commercial-color-preview-bar {
          display: block;
          width: 100%;
          max-width: 800px;
          height: 130px;
          border-radius: 14px;
          margin: 0 auto 30px auto;
          position: relative;
          overflow: hidden;
          transition: background-color 0.45s ease, opacity 0.35s ease;
          opacity: 0;
        }
        #commercial-color-preview-bar.is-visible {
          opacity: 1;
        }
      `;
      document.head.appendChild(s);
    }

    const bar = document.createElement('div');
    bar.id = 'commercial-color-preview-bar';

    // Find the step container (the .vb-block or shopify-section that wraps the swatches)
    // and insert the bar BEFORE it (outside / above the step container entirely)
    const stepContainer =
      swatchContainer.closest('.shopify-section') ||
      swatchContainer.closest('.vb-block')        ||
      swatchContainer.parentNode;

    stepContainer.parentNode.insertBefore(bar, stepContainer);

    // Default to Lite Gray immediately
    updateColorPreviewBar('lite_gray');
    bar.classList.add('is-visible');

    console.log('✅ Commercial color preview bar inserted (above step container)');
  }

  function updateColorPreviewBar(colorKey) {
    const bar = document.getElementById('commercial-color-preview-bar');
    if (!bar) return;

    const hex = EPOXY_COLOR_HEX[colorKey];
    if (!hex) return;

    bar.style.backgroundColor = hex;
    // Thin border only for White so the bar edge is visible against a white page
    bar.style.border = colorKey === 'white'
      ? '1px solid #e0e0e0'
      : 'none';

    if (!bar.classList.contains('is-visible')) {
      requestAnimationFrame(() => bar.classList.add('is-visible'));
    }
  }

  setTimeout(initColorPreviewBar, 300);
  setTimeout(initColorPreviewBar, 800);
  document.addEventListener('DOMContentLoaded', initColorPreviewBar);

  /* =====================================
     STEP 4 – SQ FT DETECTION
  ===================================== */

  function parseSqftRange(text) {
    const t = String(text || '').replace(/,/g, '').replace(/\s+/g, ' ').toLowerCase();

    let m = t.match(/(\d+)\s*[-–]\s*(\d+)\s*sqft/);
    if (m) return { min: parseInt(m[1], 10), max: parseInt(m[2], 10) };

    m = t.match(/(\d+)\s*sqft/);
    if (m) return { min: parseInt(m[1], 10), max: parseInt(m[1], 10) };

    return null;
  }

  function getKingSelectedNode(block) {
    return (
      block.querySelector('.vb-pill.is-active, .vb-swatch.is-active') ||
      block.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') ||
      (function () {
        const sel = block.querySelector('select');
        return sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
      })()
    );
  }

  function updateSqftFromKing() {
    const block = Array.from(document.querySelectorAll('.vb .vb-block[data-key="king"]')).find(b => {
      const title = (b.getAttribute('data-title') || '').toLowerCase();
      if (title.includes('application') || title.includes('tool')) return false;
      return (
        b.innerText.toLowerCase().includes('sqft') ||
        b.innerText.toLowerCase().includes('square foot')
      );
    });

    if (!block) return;

    const node = getKingSelectedNode(block);
    if (!node) return;

    const label =
      node.getAttribute?.('data-variant-title') ||
      node.getAttribute?.('data-label') ||
      node.textContent ||
      '';

    const range = parseSqftRange(label);
    if (!range) return;

    const cents = Number(
      node.getAttribute?.('data-price') ||
      node.dataset?.price ||
      0
    ) || 0;

    window.__METALLIC_KIT_STATE__.sqft = {
      label: label.trim(),
      min: range.min,
      max: range.max
    };
    window.__METALLIC_KIT_STATE__.sqftPrice = cents / 100;

    recalcTotal();

    if (typeof window.__updateTopCoatQtyChips === 'function') {
      window.__updateTopCoatQtyChips();
    }
    if (typeof window.__updateOdorBlockQtyChip === 'function') {
      window.__updateOdorBlockQtyChip();
    }
  }

  setTimeout(updateSqftFromKing, 300);
  document.addEventListener('vb:changed', updateSqftFromKing);
  document.addEventListener('click', () => setTimeout(updateSqftFromKing, 0), true);
  document.addEventListener('change', () => setTimeout(updateSqftFromKing, 0), true);

  /* =====================================
     STEP 5.1 – SQ FT → KIT QTY TABLE
  ===================================== */

  const SQFT_KIT_TABLE = [
    { max:   400, epoxy:  1 },
    { max:   800, epoxy:  2 },
    { max:  1200, epoxy:  3 },
    { max:  1600, epoxy:  4 },
    { max:  2000, epoxy:  5 },
    { max:  2400, epoxy:  6 },
    { max:  2800, epoxy:  7 },
    { max:  3200, epoxy:  8 },
    { max:  3600, epoxy:  9 },
    { max:  4000, epoxy: 10 },
    { max:  4400, epoxy: 11 },
    { max:  4800, epoxy: 12 },
    { max:  5200, epoxy: 13 },
    { max:  5600, epoxy: 14 },
    { max:  6000, epoxy: 15 },
    { max:  6400, epoxy: 16 },
    { max:  6800, epoxy: 17 },
    { max:  7200, epoxy: 18 },
    { max:  7600, epoxy: 19 },
    { max:  8000, epoxy: 20 },
    { max:  8400, epoxy: 21 },
    { max:  8800, epoxy: 22 },
    { max:  9200, epoxy: 23 },
    { max:  9600, epoxy: 24 },
    { max: 10000, epoxy: 25 }
  ];

  function getKitForSqft(maxSqft) {
    return SQFT_KIT_TABLE.find(row => maxSqft <= row.max) ||
           SQFT_KIT_TABLE[SQFT_KIT_TABLE.length - 1];
  }

  /* =====================================
     STEP 6A – BASE COLOR SWATCH (SINGLE SELECT)
  ===================================== */

  function normalizeColor(str) {
    return str
      .toLowerCase()
      .replace(/grey/g, 'gray')
      .replace(/[^a-z]/g, '_')
      .replace(/_+/g, '_')
      .trim();
  }

  const EPOXY_SWATCH_CONTAINER_SELECTOR = '.vb-swatches';

  function clearEpoxySwatchSelection(container) {
    container.querySelectorAll('.vb-swatch').forEach(btn => {
      btn.classList.remove('is-active', 'active');
      btn.setAttribute('aria-checked', 'false');
    });
  }

  function initEpoxySwatchListener() {
    // Ensure preview bar exists before attaching listener
    initColorPreviewBar();

    const container = document.querySelector(EPOXY_SWATCH_CONTAINER_SELECTOR);
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const swatch = e.target.closest('.vb-swatch');
      if (!swatch || !container.contains(swatch)) return;

      const label =
        swatch.getAttribute('data-label') ||
        swatch.getAttribute('aria-label');

      if (!label) return;

      const colorKey = normalizeColor(label);
      if (!CONFIG.epoxyColors[colorKey]) return;

      clearEpoxySwatchSelection(container);
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-checked', 'true');

      console.log('🎨 Base color selected:', colorKey);

      window.__METALLIC_KIT_STATE__.epoxyColor = colorKey;
      window.__METALLIC_KIT_STATE__.epoxyVariantId = CONFIG.epoxyColors[colorKey] || null;

      // ← Show the color preview bar
      updateColorPreviewBar(colorKey);
    });
  }

  setTimeout(initEpoxySwatchListener, 300);

  /* =====================================
     STEP 7 – UPGRADE QTY TABLE
  ===================================== */

  const UPGRADE_QTY_BY_SQFT = [
    { max:   400, wb:  2, premera:  1, mvr:  1, easymvb:  2, satin:  1, gloss:  1, aqualab:  1, labfender:  1, polygloss:  3, t2:  1 },
    { max:   800, wb:  4, premera:  2, mvr:  2, easymvb:  4, satin:  2, gloss:  2, aqualab:  2, labfender:  2, polygloss:  5, t2:  2 },
    { max:  1200, wb:  6, premera:  3, mvr:  3, easymvb:  5, satin:  3, gloss:  3, aqualab:  3, labfender:  3, polygloss:  8, t2:  3 },
    { max:  1600, wb:  8, premera:  4, mvr:  4, easymvb:  7, satin:  4, gloss:  4, aqualab:  4, labfender:  4, polygloss: 10, t2:  4 },
    { max:  2000, wb: 10, premera:  5, mvr:  5, easymvb:  8, satin:  5, gloss:  5, aqualab:  5, labfender:  5, polygloss: 13, t2:  5 },
    { max:  2400, wb: 12, premera:  6, mvr:  6, easymvb: 10, satin:  6, gloss:  6, aqualab:  6, labfender:  6, polygloss: 15, t2:  6 },
    { max:  2800, wb: 14, premera:  7, mvr:  7, easymvb: 12, satin:  7, gloss:  7, aqualab:  7, labfender:  7, polygloss: 18, t2:  7 },
    { max:  3200, wb: 16, premera:  8, mvr:  8, easymvb: 13, satin:  8, gloss:  8, aqualab:  8, labfender:  8, polygloss: 20, t2:  8 },
    { max:  3600, wb: 18, premera:  9, mvr:  9, easymvb: 15, satin:  8, gloss:  8, aqualab:  8, labfender:  8, polygloss: 23, t2:  9 },
    { max:  4000, wb: 20, premera: 10, mvr:  10, easymvb: 16, satin:  9, gloss:  9, aqualab:  9, labfender:  9, polygloss: 25, t2: 10 },
    { max:  4400, wb: 22, premera: 11, mvr: 11, easymvb: 18, satin: 10, gloss: 10, aqualab: 10, labfender: 10, polygloss: 27, t2: 11 },
    { max:  4800, wb: 24, premera: 12, mvr: 12, easymvb: 20, satin: 11, gloss: 11, aqualab: 11, labfender: 11, polygloss: 30, t2: 12 },
    { max:  5200, wb: 26, premera: 13, mvr: 13, easymvb: 21, satin: 12, gloss: 12, aqualab: 12, labfender: 12, polygloss: 32, t2: 13 },
    { max:  5600, wb: 28, premera: 14, mvr: 14, easymvb: 23, satin: 13, gloss: 13, aqualab: 13, labfender: 13, polygloss: 35, t2: 14 },
    { max:  6000, wb: 30, premera: 15, mvr: 15, easymvb: 24, satin: 14, gloss: 14, aqualab: 14, labfender: 14, polygloss: 37, t2: 15 },
    { max:  6400, wb: 32, premera: 16, mvr: 16, easymvb: 26, satin: 15, gloss: 15, aqualab: 15, labfender: 15, polygloss: 40, t2: 16 },
    { max:  6800, wb: 34, premera: 17, mvr: 17, easymvb: 28, satin: 16, gloss: 16, aqualab: 16, labfender: 16, polygloss: 42, t2: 17 },
    { max:  7200, wb: 36, premera: 18, mvr: 18, easymvb: 29, satin: 16, gloss: 16, aqualab: 16, labfender: 16, polygloss: 45, t2: 18 },
    { max:  7600, wb: 38, premera: 19, mvr: 19, easymvb: 31, satin: 17, gloss: 17, aqualab: 17, labfender: 17, polygloss: 47, t2: 19 },
    { max:  8000, wb: 40, premera: 20, mvr: 20, easymvb: 32, satin: 18, gloss: 18, aqualab: 18, labfender: 18, polygloss: 50, t2: 20 },
    { max:  8400, wb: 42, premera: 21, mvr: 21, easymvb: 34, satin: 19, gloss: 19, aqualab: 19, labfender: 19, polygloss: 52, t2: 21 },
    { max:  8800, wb: 44, premera: 22, mvr: 22, easymvb: 36, satin: 20, gloss: 20, aqualab: 20, labfender: 20, polygloss: 54, t2: 22 },
    { max:  9200, wb: 46, premera: 23, mvr: 23, easymvb: 37, satin: 21, gloss: 21, aqualab: 21, labfender: 21, polygloss: 57, t2: 23 },
    { max:  9600, wb: 48, premera: 24, mvr: 24, easymvb: 39, satin: 22, gloss: 22, aqualab: 22, labfender: 22, polygloss: 59, t2: 24 },
    { max: 10000, wb: 50, premera: 25, mvr: 25, easymvb: 40, satin: 23, gloss: 23, aqualab: 23, labfender: 23, polygloss: 62, t2: 25 }
  ];

  function getUpgradeQtyForSqft(key, sqftMax) {
    const row =
      UPGRADE_QTY_BY_SQFT.find(r => sqftMax <= r.max) ||
      UPGRADE_QTY_BY_SQFT[UPGRADE_QTY_BY_SQFT.length - 1];

    switch (key) {
      case 'wb_epoxy_primer':           return row.wb;
      case 'premera_fp_fusion_primer':  return row.premera;
      case 'moisture_vapor_barrier':    return row.mvr;
      case 'premera_easymvb':           return row.easymvb;
      case 'high_wear_urethane_finish': return row.satin;
      case 'urethane_satin':            return row.satin;
      case 'urethane_gloss':            return row.gloss;
      case 'aqualab':                   return row.aqualab;
      case 'labfender':                 return row.labfender;
      case 'polygloss':                 return row.polygloss;
      case 'premera_t2':                return row.t2;
      case 'odor_block':                return row.t2;
      case 'fine_anti_slip':            return 1;
      default:                          return 1;
    }
  }

  /* =====================================
     STEP 7A – UPGRADE SELECTION (PILLS)
  ===================================== */

  function normalizeUpgradeKey(str) {
    return str.toLowerCase().replace(/[^a-z]/g, '_').replace(/_+/g, '_').trim();
  }

  const PRIMER_UPGRADE_KEYS = [
    'wb_epoxy_primer',
    'premera_fp_fusion_primer',
    'moisture_vapor_barrier'
  ];

  function getUpgradeKeyFromButton(btn) {
    return normalizeUpgradeKey(btn.getAttribute('data-variant-title') || '');
  }

  function initUpgradeListener() {
    const container = document.querySelector('.vb-grid-picker_Bq4dpD');
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = e.target.closest('.vb-pill');
      if (!btn || !container.contains(btn)) return;

      const title = btn.getAttribute('data-variant-title');
      if (!title) return;

      const key = normalizeUpgradeKey(title);
      const price = parseFloat(btn.getAttribute('data-price')) / 100 || 0;
      const state = window.__METALLIC_KIT_STATE__;

      if (!state.upgrades) state.upgrades = {};

      if (state.upgrades[key]) {
        delete state.upgrades[key];
        btn.classList.remove('is-active');
        btn.setAttribute('aria-checked', 'false');
      } else {
        if (PRIMER_UPGRADE_KEYS.includes(key)) {
          container.querySelectorAll('.vb-pill').forEach(pill => {
            const pillKey = getUpgradeKeyFromButton(pill);
            if (PRIMER_UPGRADE_KEYS.includes(pillKey)) {
              pill.classList.remove('is-active');
              pill.setAttribute('aria-checked', 'false');
              delete state.upgrades[pillKey];
            }
          });
        }

        const upgradeEntry = { price: price };
        // Try to get the id from the DOM variant id
        const domId = parseInt(btn.dataset.variantId, 10);
        if (domId) upgradeEntry.id = domId;
        upgradeEntry.type = 'auto';

        state.upgrades[key] = upgradeEntry;
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
      }

      recalcTotal();
    });
  }

  setTimeout(initUpgradeListener, 300);

  /* =====================================
     STEP T1 – TOOL KIT
  ===================================== */

  const APP_VARIANT_MAP = {
    53369387155759: { id: 45756361965871,  type: 'manual',  label: 'Crack and Joint Paste 2 Gallon' },
    53369488408879: { id: 52413208887599,  type: 'manual',  label: 'Crack and Joint Paste 1/2 Gallon' },
    53369488441647: { id: 51834205307183,  type: 'toolkit', label: 'Partial Flake and Solid Color Floor Tool Kit' },
    53369387188527: { id: 45756243214639,  type: 'auto',    label: 'Fine Anti Slip 12 OZ', upgradeKey: 'fine_anti_slip' },
    53369488507183: { id: 45756243181871,  type: 'manual',  label: 'Course Anti Slip 12 OZ' },
    54332602220847: { id: 54319311782191,  type: 'toolkit', label: 'Polyaspartic Application Tool Kit' }
  };


  /* =====================================
     STEP MVB – PRIMERS & MVB RADIO BLOCK
  ===================================== */

  const MVB_VARIANT_MAP = {
    58052359192879: { upgradeKey: 'wb_epoxy_primer',          id: 54547287965999 },
    58052359225647: { upgradeKey: 'moisture_vapor_barrier',   id: 58052359225647 },
    58052359258415: { upgradeKey: 'premera_fp_fusion_primer', id: 58052359258415 },
    58052359291183: { upgradeKey: 'moisture_vapor_barrier',   id: 55542586868015 }
  };

  function initMVBBlockListener() {
    const block = document.querySelector('.vb .vb-block[data-key="mvb"]');
    if (!block) return;

    block.addEventListener('change', function (e) {
      const input = e.target;
      if (!input || input.type !== 'radio') return;

      const state = window.__METALLIC_KIT_STATE__;
      state.mvbSelection = null;

      if (input.dataset.none === 'true' || !input.value) {
        recalcTotal();
        return;
      }

      if (!state.sqft) {
        alert('Please select square footage first');
        const noneRadio = block.querySelector('input[data-none="true"]');
        if (noneRadio) noneRadio.checked = true;
        return;
      }

      const label = input.closest('label') || input.parentElement;
      const domVariantId = Number(input.dataset.variantId || label?.dataset.variantId || label?.getAttribute('data-variant-id'));
      const price        = Number(input.dataset.price || label?.dataset.price || label?.getAttribute('data-price') || 0) / 100;
      const title        = input.dataset.variantTitle || label?.dataset.variantTitle || label?.getAttribute('data-variant-title') || '';
      const mapped       = MVB_VARIANT_MAP[domVariantId];

      if (!mapped) {
        console.warn('⚠️ No MVB variant map entry for DOM variant ID:', domVariantId);
        return;
      }

      const qty = getUpgradeQtyForSqft(mapped.upgradeKey, state.sqft.max);

      state.mvbSelection = {
        id:         mapped.id,
        qty:        qty,
        price:      price,
        upgradeKey: mapped.upgradeKey,
        title:      title
      };

      console.log('💧 MVB/Primer selected:', title, '×', qty, '→ cart ID:', mapped.id);
      recalcTotal();
    });
  }

  setTimeout(initMVBBlockListener, 300);

  /* =====================================
     STEP TOPCOAT – TOP COAT RADIO BLOCK
  ===================================== */

  const TOPCOAT_VARIANT_MAP = {
    56460946407727: { id: 45756210348335, upgradeKey: 'urethane_satin'  },
    56460946473263: { id: 45756210315567, upgradeKey: 'urethane_gloss'  },
    56460946538799: { id: 50200846958895, upgradeKey: 'aqualab'         },
    56460946604335: { id: 50873632817455, upgradeKey: 'labfender'       },
    56460946669871: { id: 50486066217263, upgradeKey: 'polygloss'       },
    56460946735407: { id: 45756244394287, upgradeKey: 'premera_t2'      },
    56460946800943: { id: 52100974117167, upgradeKey: 'odor_block'      }
  };

  function initTopCoatBlockListener() {
    const block = document.querySelector('.vb .vb-block[data-key="topcoat"]');
    if (!block) return;

    block.addEventListener('change', function (e) {
      const input = e.target;
      if (!input || input.type !== 'radio') return;

      const state = window.__METALLIC_KIT_STATE__;
      state.topCoatSelection = null;
      state.topCoatTouched = true;

      if (input.dataset.none === 'true' || !input.value) {
        recalcTotal();
        return;
      }

      if (!state.sqft) {
        alert('Please select square footage first');
        const noneRadio = block.querySelector('input[data-none="true"]');
        if (noneRadio) noneRadio.checked = true;
        return;
      }

      const label = input.closest('label') || input.parentElement;
      const domVariantId = Number(input.dataset.variantId || label?.dataset.variantId || label?.getAttribute('data-variant-id'));
      const price        = Number(input.dataset.price || label?.dataset.price || label?.getAttribute('data-price') || 0) / 100;
      const title        = input.dataset.variantTitle || label?.dataset.variantTitle || label?.getAttribute('data-variant-title') || '';
      const mapped       = TOPCOAT_VARIANT_MAP[domVariantId];

      if (!mapped) {
        console.warn('⚠️ No Top Coat variant map entry for DOM variant ID:', domVariantId);
        return;
      }

      const qty = getUpgradeQtyForSqft(mapped.upgradeKey, state.sqft.max);

      state.topCoatSelection = {
        id:         mapped.id,
        qty:        qty,
        price:      price,
        upgradeKey: mapped.upgradeKey,
        title:      title
      };

      console.log('🎨 Top Coat selected:', title, '×', qty);
      recalcTotal();
    });
  }

  setTimeout(initTopCoatBlockListener, 300);
  setTimeout(recalcTotal, 500);
  setTimeout(recalcTotal, 1200);

  /* =====================================
     STEP APP – APPLICATION PRODUCTS & TOOLS
  ===================================== */

  function initAppBlockListener() {
    const appBlock = Array.from(document.querySelectorAll('.vb-block[data-key="king"]')).find(b =>
      (b.getAttribute('data-title') || '').toLowerCase().includes('application')
    );
    const container = appBlock ? appBlock.querySelector('.vb-grid') : null;
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = e.target.closest('.vb-pill');
      if (!btn || !container.contains(btn)) return;

      const state = window.__METALLIC_KIT_STATE__;
      if (!state.sqft) { alert('Please select square footage first'); return; }

      const domVariantId = Number(btn.dataset.variantId);
      const price        = Number(btn.getAttribute('data-price') || 0) / 100;
      const mapped       = APP_VARIANT_MAP[domVariantId];

      if (!mapped) {
        console.warn('⚠️ No APP variant map entry for DOM variant ID:', domVariantId);
        return;
      }

      if (!mapped.id) {
        alert('This option is not yet available. Please check back soon.');
        return;
      }

      const isActive = btn.classList.contains('is-active');

      if (mapped.type === 'toolkit') {
        container.querySelectorAll('.vb-pill').forEach(b => {
          const bMapped = APP_VARIANT_MAP[Number(b.dataset.variantId)];
          if (bMapped && bMapped.type === 'toolkit') {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          }
        });

        if (isActive) {
          state.toolkit = null;
          state.toolkitPrice = 0;
        } else {
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          state.toolkit = { id: mapped.id };
          state.toolkitPrice = price;
        }

        recalcTotal();
        return;
      }

      if (!state.appItems) state.appItems = {};

      if (isActive) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-checked', 'false');
        delete state.appItems[domVariantId];
      } else {
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        state.appItems[domVariantId] = {
          id:         mapped.id,
          price:      price,
          type:       mapped.type,
          label:      mapped.label,
          upgradeKey: mapped.upgradeKey || null
        };
      }

      recalcTotal();
    });
  }

  setTimeout(initAppBlockListener, 300);
  setTimeout(function syncPreselectedAppItems() {
    const appBlock = Array.from(document.querySelectorAll('.vb-block[data-key="king"]')).find(b =>
      (b.getAttribute('data-title') || '').toLowerCase().includes('application')
    );
    if (!appBlock) return;

    const state = window.__METALLIC_KIT_STATE__;
    if (!state.appItems) state.appItems = {};

    appBlock.querySelectorAll('.vb-pill.is-active').forEach(btn => {
      const domVariantId = Number(btn.dataset.variantId);
      const price = Number(btn.getAttribute('data-price') || 0) / 100;
      const mapped = APP_VARIANT_MAP[domVariantId];
      if (!mapped || !mapped.id) return;

      if (mapped.type === 'toolkit') {
        state.toolkit = { id: mapped.id };
        state.toolkitPrice = price;
        return;
      }

      state.appItems[domVariantId] = {
        id:         mapped.id,
        price:      price,
        type:       mapped.type,
        label:      mapped.label,
        upgradeKey: mapped.upgradeKey || null
      };
    });

    recalcTotal();
  }, 800);

  /* =====================================
     VALIDATE + CART HELPERS
  ===================================== */

  function showKitError(message) {
    let banner = document.getElementById('kit-validation-error');
    if (!banner) {
      if (!document.getElementById('kit-error-css')) {
        const style = document.createElement('style');
        style.id = 'kit-error-css';
        style.textContent = `
          #kit-validation-error {
            display: flex;
            align-items: center;
            gap: 10px;
            background: #fff0f0;
            border: 1px solid #f5c2c2;
            border-radius: 8px;
            color: #b91c1c;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.5;
            padding: 12px 16px;
            margin-top: 12px;
            animation: kitErrorShake 0.35s ease;
          }
          @keyframes kitErrorShake {
            0%,100% { transform: translateX(0); }
            25%      { transform: translateX(-6px); }
            75%      { transform: translateX(6px); }
          }
          #kit-validation-error .kit-error-icon {
            font-size: 18px;
            flex-shrink: 0;
          }
          @media (max-width: 767px) {
            #kit-validation-error {
              position: fixed;
              bottom: 0;
              left: 0;
              right: 0;
              margin: 0;
              border-radius: 0;
              border-left: none;
              border-right: none;
              border-bottom: none;
              z-index: 99999;
              box-shadow: 0 -4px 16px rgba(185,28,28,0.12);
              justify-content: center;
              text-align: center;
            }
          }
        `;
        document.head.appendChild(style);
      }
      banner = document.createElement('div');
      banner.id = 'kit-validation-error';
      const addBtn = document.querySelector('.vb-add-btn');
      if (addBtn && addBtn.parentNode) {
        addBtn.parentNode.insertBefore(banner, addBtn);
      } else {
        document.body.appendChild(banner);
      }
    }
    banner.innerHTML = `<span class="kit-error-icon">⚠️</span><span>${message}</span>`;
    banner.style.display = 'flex';
    banner.style.animation = 'none';
    banner.offsetHeight;
    banner.style.animation = '';
    banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearKitError() {
    const banner = document.getElementById('kit-validation-error');
    if (banner) banner.style.display = 'none';
  }

  function scrollToBlock(blockKey) {
    const block = document.querySelector(`.vb-block[data-key="${blockKey}"]`);
    if (!block) return;
    const headerHeight = document.querySelector('header')?.offsetHeight || 120;
    const top = block.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function validateKitState() {
    const state = window.__METALLIC_KIT_STATE__ || {};

    if (!state.sqft) {
      showKitError('Please select a square footage before adding to cart.');
      return false;
    }

    if (!state.epoxyColor) {
      const activeSwatch = document.querySelector(
        '.vb-swatches .vb-swatch.is-active, .vb-swatches .vb-swatch[aria-checked="true"]'
      );
      if (activeSwatch) {
        const lbl = activeSwatch.getAttribute('data-label') || activeSwatch.getAttribute('aria-label');
        if (lbl) state.epoxyColor = normalizeColor(lbl);
      }
    }

    if (!state.epoxyColor) {
      showKitError('Please select a base color before adding to cart.');
      return false;
    }

    if (!state.mvbSelection) {
      showKitError('Please select a primer or moisture vapor barrier before adding to cart.');
      scrollToBlock('mvb');
      return false;
    }

    if (!state.topCoatSelection && !state.topCoatTouched) {
      showKitError('Please select a top coat before adding to cart.');
      scrollToBlock('topcoat');
      return false;
    }

    clearKitError();
    return true;
  }

  function getBundleVariantForSqft(maxSqft) {
    const limits = Object.keys(BUNDLE_VARIANTS).map(Number).sort((a, b) => a - b);
    return BUNDLE_VARIANTS[limits.find(limit => maxSqft <= limit)];
  }

  function safePush(items, item, label) {
    if (!item || !item.id || isNaN(item.id)) {
      console.error(`❌ Skipped invalid item (${label}):`, item);
      return;
    }
    if (!item.quantity || item.quantity < 1) {
      console.error(`❌ Skipped invalid quantity (${label}):`, item);
      return;
    }
    items.push(item);
  }

  function buildPolyItems(totalQty, bundleId) {
    const POLY_3GAL = 51170277785903;
    const POLY_2GAL = 51122611945775;
    const POLY_1GAL = 50486066217263;
    const props = { _bundle_id: bundleId, _bundle_role: 'topcoat', _upgrade: 'polygloss', _kit: 'epoxy' };
    const result = [];
    if (totalQty % 3 === 0) {
      result.push({ id: POLY_3GAL, quantity: totalQty / 3, properties: props });
    } else if (totalQty % 2 === 0) {
      result.push({ id: POLY_2GAL, quantity: totalQty / 2, properties: props });
    } else {
      const threes = Math.floor(totalQty / 3);
      const rem = totalQty % 3;
      if (threes > 0) result.push({ id: POLY_3GAL, quantity: threes, properties: props });
      if (rem === 2) result.push({ id: POLY_2GAL, quantity: 1, properties: props });
      else if (rem === 1) result.push({ id: POLY_1GAL, quantity: 1, properties: props });
    }
    return result;
  }

  /* =====================================
     ADD TO CART – COMMERCIAL
  ===================================== */

  async function addSelectedKitToCart() {
    if (!validateKitState()) return;

    const state = window.__METALLIC_KIT_STATE__;
    const BUNDLE_ID = `commercial-epoxy-${state.sqft.max}-${Date.now()}`;
    const kit = getKitForSqft(state.sqft.max);

    if (!kit) { alert('Invalid square footage selection'); return; }

    const items = [];

    const bundleVariantId = getBundleVariantForSqft(state.sqft.max);
    if (!bundleVariantId) { alert('Unable to determine bundle price for selected Sq Ft'); return; }

    // 1. Bundle parent (pricing line item)
    items.push({
      id: bundleVariantId,
      quantity: 1,
      properties: {
        _bundle_id:     BUNDLE_ID,
        _bundle_parent: BUNDLE_ID,
        _bundle_title:  'Commercial Epoxy Floor Kit',
        _sqft:          state.sqft.label
      }
    });

    // 2. Tool Kit and its included tools
    if (state.toolkit && state.toolkit.id) {
      const toolkitId = String(state.toolkit.id);
      const toolkitChildren =
        (window.__TOOLKIT_CHILD_ITEMS__ &&
          window.__TOOLKIT_CHILD_ITEMS__[toolkitId]) || [];

      items.push({
        id: state.toolkit.id,
        quantity: 1,
        properties: {
          _bundle_id: BUNDLE_ID,
          _bundle_role: 'toolkit',
          _toolkit: 'true',
          _parent_toolkit_id: toolkitId
        }
      });

      items.push(...toolkitChildren.map(child => ({
        id: Number(child.variantId),
        quantity: Number(child.quantity),
        properties: {
          _bundle_id: BUNDLE_ID,
          _toolkit_child: 'true',
          _bundle_role: 'toolkit-item',
          _toolkit_item_label: child.label,
          _parent_toolkit_id: toolkitId,
          Included: 'Tool Kit'
        }
      })));

      console.log('🧰 Tool Kit and included tools added:', state.toolkit);
    }

    // 3. MVB / Primer
    if (state.mvbSelection && state.mvbSelection.id) {
      safePush(items, {
        id:       state.mvbSelection.id,
        quantity: state.mvbSelection.qty || 1,
        properties: {
          _bundle_id:    BUNDLE_ID,
          _bundle_child: 'true',
          _bundle_role:  'primer',
          _upgrade:      state.mvbSelection.upgradeKey,
          Included:      'Commercial Epoxy Floor Kit'
        }
      }, 'MVB/Primer');
      console.log(`💧 MVB: ${state.mvbSelection.title} ×${state.mvbSelection.qty}`);
    }

    // 4. EasyMVB (checkbox add-on)
    if (state.easyMVBSelected) {
      const easyQty = getUpgradeQtyForSqft('premera_easymvb', state.sqft.max);
      safePush(items, {
        id:       55542586868015,
        quantity: easyQty,
        properties: { _bundle_id: BUNDLE_ID, _bundle_role: 'primer', _upgrade: 'premera_easymvb' }
      }, 'Premera EasyMVB');
      console.log(`🧪 EasyMVB ×${easyQty}`);
    }

    // 5. Top Coat
    if (state.topCoatSelection && state.topCoatSelection.id) {
      if (state.topCoatSelection.upgradeKey === 'polygloss') {
        buildPolyItems(state.topCoatSelection.qty || 1, BUNDLE_ID).forEach(item => items.push(item));
        console.log(`🎨 Poly Gloss (split) ×${state.topCoatSelection.qty}`);
      } else {
        safePush(items, {
          id:       state.topCoatSelection.id,
          quantity: state.topCoatSelection.qty || 1,
          properties: {
            _bundle_id:   BUNDLE_ID,
            _bundle_role: 'topcoat',
            _upgrade:     state.topCoatSelection.upgradeKey,
            _kit:         'epoxy'
          }
        }, 'Top Coat');
        console.log(`🎨 Top Coat: ${state.topCoatSelection.title} ×${state.topCoatSelection.qty}`);
      }
    }

    // 6. Odor Block (checkbox, requires T-2)
    if (state.odorBlockSelected && state.topCoatSelection) {
      const odorQty = getUpgradeQtyForSqft('premera_t2', state.sqft.max);
      safePush(items, {
        id:       52100974117167,
        quantity: odorQty,
        properties: { _bundle_id: BUNDLE_ID, _bundle_role: 'topcoat', _upgrade: 'odor_block', _kit: 'epoxy' }
      }, 'Odor Block');
      console.log(`🧪 Odor Block ×${odorQty}`);
    }

    // 7. Application products & tools
    Object.values(state.appItems || {}).forEach(item => {
      let qty = 1;
      if (item.type === 'auto' && item.upgradeKey) {
        qty = getUpgradeQtyForSqft(item.upgradeKey, state.sqft.max);
      }

      const isToolkit = item.type === 'toolkit';

      safePush(items, {
        id:       item.id,
        quantity: qty,
        properties: {
          _bundle_id:    BUNDLE_ID,
          _bundle_role:  isToolkit ? 'toolkit' : 'upgrades',
          _toolkit:      isToolkit ? 'true' : undefined,
          _upgrade:      item.upgradeKey || item.label,
          _kit:          'epoxy',
          Included:      isToolkit ? undefined : 'Commercial Epoxy Floor Kit'
        }
      }, item.label);
      console.log(`🔧 App item: ${item.label} ×${qty}`);
    });

    // 8. Legacy upgrade pills (if any grid-picker upgrades selected)
    Object.keys(state.upgrades || {}).forEach(key => {
      const upgrade = state.upgrades[key];
      let qty = upgrade.type === 'auto' ? getUpgradeQtyForSqft(key, state.sqft.max)
              : upgrade.type === 'manual' ? (upgrade.qty || 1)
              : 1;

      if (!upgrade.id || isNaN(upgrade.id)) {
        console.error('❌ Invalid upgrade ID for:', key, upgrade);
        return;
      }

      items.push({
        id: upgrade.id,
        quantity: qty,
        properties: { _bundle_id: BUNDLE_ID, _upgrade: key, _kit: 'epoxy' }
      });
      console.log(`🧩 Upgrade: ${key} ×${qty}`);
    });

    // 9. Solid color epoxy (pre-pigmented base coat)
    safePush(items, {
      id:       state.epoxyVariantId || CONFIG.epoxyColors[state.epoxyColor],
      quantity: kit.epoxy,
      properties: {
        _bundle_id:    BUNDLE_ID,
        _bundle_child: 'true',
        _bundle_role:  'epoxy-color',
        Included:      'Commercial Epoxy Floor Kit'
      }
    }, 'Solid Color Epoxy');

    console.log('🛒 Adding commercial kit to cart:', items);
    console.log('🚨 FINAL CART PAYLOAD:', JSON.stringify(items, null, 2));

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    window.location.href = '/cart';
  }

  function initAddSelectedToCart() {
    const btn = document.querySelector('.vb-add-btn');
    if (!btn) { console.warn('Add to Cart button not found'); return; }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addSelectedKitToCart();
    }, true);

    console.log('✅ Commercial Add to Cart handler attached');
  }

  setTimeout(initAddSelectedToCart, 300);

  /* =====================================
     TOTAL DISPLAY
  ===================================== */

  function updateVBTotal(amount) {
    const vbTotalEl = document.querySelector('.vb-total-amount');
    if (vbTotalEl) vbTotalEl.style.display = 'none';

    let ourTotal = document.querySelector('.kit-custom-total');
    if (!ourTotal) {
      ourTotal = document.createElement('strong');
      ourTotal.className = 'kit-custom-total';
      ourTotal.setAttribute('data-total', '');
      if (vbTotalEl) {
        vbTotalEl.parentNode.insertBefore(ourTotal, vbTotalEl);
      }
    }

    ourTotal.textContent = `US$${amount.toFixed(2)}`;
  }

  function calcPolyGlossCost(totalQty, pricePerUnit) {
    return totalQty * pricePerUnit;
  }

  function recalcTotal() {
    const state = window.__METALLIC_KIT_STATE__;
    let total = 0;

    total += state.sqftPrice || 0;
    total += state.toolkitPrice || 0;

    if (state.mvbSelection) {
      total += (state.mvbSelection.price || 0) * (state.mvbSelection.qty || 1);
    }

    if (state.easyMVBSelected && state.sqft) {
      const mvbBlock = document.querySelector('.vb .vb-block[data-key="mvb"]');
      const easyInput = mvbBlock
        ? mvbBlock.querySelector('input[data-variant-id="58052359291183"]')
        : null;
      if (easyInput) {
        const easyPrice = Number(easyInput.getAttribute('data-price') || 0) / 100;
        const easyQty   = getUpgradeQtyForSqft('premera_easymvb', state.sqft.max);
        total += easyPrice * easyQty;
      }
    }

    if (state.topCoatSelection) {
      if (state.topCoatSelection.upgradeKey === 'polygloss') {
        total += calcPolyGlossCost(state.topCoatSelection.qty || 1, state.topCoatSelection.price || 0);
      } else {
        total += (state.topCoatSelection.price || 0) * (state.topCoatSelection.qty || 1);
      }
    }

    if (state.odorBlockSelected && state.sqft) {
      const tcBlock = document.querySelector('.vb .vb-block[data-key="topcoat"]');
      const odorInput = tcBlock
        ? tcBlock.querySelector('input[data-variant-id="56460946800943"]')
        : null;
      if (odorInput) {
        const odorPrice = Number(odorInput.getAttribute('data-price') || 0) / 100;
        const odorQty   = getUpgradeQtyForSqft('premera_t2', state.sqft.max);
        total += odorPrice * odorQty;
      }
    }

    Object.values(state.appItems || {}).forEach(item => {
      let qty = 1;
      if (item.type === 'auto' && item.upgradeKey && state.sqft) {
        qty = getUpgradeQtyForSqft(item.upgradeKey, state.sqft.max);
      }
      total += (item.price || 0) * qty;
    });

    Object.entries(state.upgrades || {}).forEach(([key, upgrade]) => {
      let qty = 1;
      if (upgrade.type === 'auto' && state.sqft) qty = getUpgradeQtyForSqft(key, state.sqft.max);
      if (upgrade.type === 'manual') qty = upgrade.qty || 1;
      total += (upgrade.price || 0) * qty;
    });

    updateVBTotal(total);
  }

  document.addEventListener('vb:changed', () => setTimeout(recalcTotal, 150));
  document.addEventListener('vb:updated', () => setTimeout(recalcTotal, 150));

  /* =====================================
     CART LOCKING – BUNDLE CHILDREN
  ===================================== */

  function lockKitItemsInCart() {
    if (!document.body.classList.contains('template-cart')) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (!item.properties) return;

          const key = item.key.replace(/:/g, '\\:');
          const row = document
            .querySelector(`[name="updates[${key}]"]`)
            ?.closest('.cart__item');

          if (!row) return;

          if (item.properties._bundle_child === 'true' && !item.properties._additional_pigment) {
            row.querySelectorAll(
              'input[type="number"], button.quantity--input__button, .cart__trash, .cart__remove'
            ).forEach(el => {
              el.disabled = true;
              el.style.pointerEvents = 'none';
              el.style.opacity = '0.5';
            });
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', lockKitItemsInCart);
  document.addEventListener('booster:content:update', lockKitItemsInCart);

  function lockAutoUpgradeQtyInCart() {
    const AUTO_UPGRADES = [
      'wb_epoxy_primer',
      'premera_fp_fusion_primer',
      'moisture_vapor_barrier',
      'premera_easymvb',
      'odor_block',
      'high_wear_urethane_finish',
      'fine_anti_slip'
    ];

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (!item.properties || !item.properties._upgrade) return;
          if (!AUTO_UPGRADES.includes(item.properties._upgrade)) return;

          const key = item.key.replace(/:/g, '\\:');
          const row = document.querySelector(`[name="updates[${key}]"]`)?.closest('.cart__item');
          if (!row) return;

          row.querySelectorAll('input[type="number"], .quantity--input__button').forEach(el => {
            el.disabled = true;
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.5';
          });
          row.querySelectorAll('.cart__trash, .cart__remove').forEach(btn => {
            btn.style.display = '';
            btn.style.pointerEvents = 'auto';
            btn.style.opacity = '1';
          });
        });
      });
  }

  document.addEventListener('DOMContentLoaded', lockAutoUpgradeQtyInCart);
  document.addEventListener('booster:content:update', lockAutoUpgradeQtyInCart);
  setTimeout(lockAutoUpgradeQtyInCart, 300);
  setTimeout(lockAutoUpgradeQtyInCart, 800);

  /* =====================================
     CART – BUNDLE REMOVAL
  ===================================== */

  function forceRemoveBundle(bundleId) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const updates = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties._bundle_id === bundleId) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      })
      .then(() => window.location.reload());
  }

  function handleSideCartBundleRemoval() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bundles = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties._bundle_id) {
            if (!bundles[item.properties._bundle_id]) {
              bundles[item.properties._bundle_id] = [];
            }
            bundles[item.properties._bundle_id].push(item);
          }
        });

        Object.keys(bundles).forEach(bundleId => {
          if (!bundleId.startsWith('commercial-epoxy-')) return;
          const items = bundles[bundleId];
          const parent = items.find(
            i => i.properties._bundle_parent === bundleId && !i.properties._bundle_child
          );
          if (!parent) {
            const updates = {};
            items.forEach(i => (updates[i.key] = 0));
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
          }
        });
      });
  }

  document.addEventListener('booster:content:update', handleSideCartBundleRemoval);
  document.addEventListener('DOMContentLoaded', handleSideCartBundleRemoval);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[onclick*="toggleBundle"]').forEach(el => {
      const match = el.getAttribute('onclick')?.match(/'([^']+)'/);
      if (!match) return;
      const bundleId = match[1];
      if (!bundleId.startsWith('commercial-epoxy-')) return;

      const container = el.closest('.cart__info');
      if (!container || container.querySelector('.bundle-remove-btn')) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-remove-btn';
      btn.textContent = 'Remove bundle';
      btn.style.cssText = 'margin-top:8px;background:none;border:none;color:#c00;cursor:pointer;font-weight:600;';
      btn.addEventListener('click', () => forceRemoveBundle(bundleId));
      container.appendChild(btn);
    });
  });

  /* =====================================
     CART – MISC DISPLAY FIXES
  ===================================== */

  function fixBundleTitles() {
    document.querySelectorAll('.cart__bundle-toggle').forEach(toggle => {
      const titleEl = toggle.querySelector('.cart__bundle-title');
      if (!titleEl) return;
      const cartItem = toggle.closest('.cart__item');
      if (!cartItem) return;

      const isCommercialBundle =
        cartItem.innerText.includes('Commercial Epoxy') ||
        cartItem.innerText.includes('commercial-epoxy-');

      if (!isCommercialBundle) return;

      const bundleInfo = toggle.closest('.cart__info--text')?.querySelector('.cart__bundle-summary');
      if (!bundleInfo) return;

      const sqftLine = [...bundleInfo.querySelectorAll('li')].find(li => li.textContent.includes('SQFT'));
      if (!sqftLine) return;

      const sqftMatch = sqftLine.textContent.match(/(\d+\s*-\s*\d+\s*SQFT)/i);
      if (!sqftMatch) return;

      titleEl.textContent = `Commercial Epoxy Floor Kit – ${sqftMatch[1]}`;
    });
  }

  document.addEventListener('DOMContentLoaded', fixBundleTitles);
  document.addEventListener('booster:content:update', fixBundleTitles);
  setTimeout(fixBundleTitles, 500);
  setTimeout(fixBundleTitles, 1200);

  function hideBundleSelfLine() {
    document.querySelectorAll('.cart__bundle-summary-line').forEach(line => {
      if (line.textContent.includes('Commercial Epoxy')) {
        line.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', hideBundleSelfLine);
  document.addEventListener('booster:content:update', hideBundleSelfLine);
  setTimeout(hideBundleSelfLine, 300);

  function fixPolyGlossCartLabels() {
    const POLY_SIZE_MAP = {
      '50486066217263': '1 Gal Kit',
      '51122611945775': '2 Gal Kit',
      '51170277785903': '3 Gal Kit'
    };
    document.querySelectorAll('.cart__item[data-item-key]').forEach(row => {
      const key = row.getAttribute('data-item-key') || '';
      const variantId = key.split(':')[0];
      const size = POLY_SIZE_MAP[variantId];
      if (!size) return;
      const textEl = row.querySelector('.cart__info--text span, .cart__info--text a');
      if (!textEl) return;
      const current = textEl.textContent || '';
      if (!current.includes('Poly Gloss') || current.includes(size)) return;
      textEl.textContent = current.replace(
        /^(Poly Gloss 85 Slow Go Polyaspartic)\s*[–\-]\s*(\d+\s*Set)$/,
        `$1 – ${size} - $2`
      );
    });
  }

  document.addEventListener('DOMContentLoaded', fixPolyGlossCartLabels);
  document.addEventListener('booster:content:update', fixPolyGlossCartLabels);
  setTimeout(fixPolyGlossCartLabels, 300);
  setTimeout(fixPolyGlossCartLabels, 800);

  function lockSideCartChildItems() {
    const drawer = document.querySelector('.qsc2-drawer-rows');
    if (!drawer) return;
    drawer.querySelectorAll('.qsc2-product-item-wrapper').forEach(item => {
      if (!item.innerText.includes('Included: Commercial Epoxy Floor Kit')) return;
      item.querySelectorAll('button, a').forEach(btn => {
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.4';
        btn.disabled = true;
      });
    });
  }

  document.addEventListener('booster:content:update', lockSideCartChildItems);
  document.addEventListener('DOMContentLoaded', lockSideCartChildItems);
  setTimeout(lockSideCartChildItems, 300);
  setTimeout(lockSideCartChildItems, 800);

  function lockSideCartUpgradeQty() {
    const upgradesSection = document.querySelector('.sidecart-section.sidecart-upgrades');
    if (!upgradesSection) return;
    upgradesSection.querySelectorAll('.qsc2-product-item').forEach(item => {
      const title = item.querySelector('.qsc2-product-item__product-title')?.innerText.toLowerCase() || '';
      const isCrackAndJoint = title.includes('crack') && title.includes('joint');
      if (isCrackAndJoint) {
        item.querySelectorAll('.qsc2-product-item__quantity-input, .qsc2-quantity-btn--plus, .qsc2-quantity-btn--minus').forEach(el => {
          el.disabled = false;
          el.style.pointerEvents = 'auto';
          el.style.opacity = '1';
        });
        return;
      }
      item.querySelectorAll('.qsc2-product-item__quantity-input, .qsc2-quantity-btn--plus, .qsc2-quantity-btn--minus').forEach(el => {
        el.disabled = true;
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      });
      item.querySelectorAll('.qsc2-product-item__remove-btn').forEach(btn => {
        btn.disabled = false;
        btn.style.pointerEvents = 'auto';
        btn.style.opacity = '1';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', lockSideCartUpgradeQty);
  document.addEventListener('booster:content:update', lockSideCartUpgradeQty);
  setTimeout(lockSideCartUpgradeQty, 300);
  setTimeout(lockSideCartUpgradeQty, 800);

  // Hide bundle parent row from cart page
  (function hideBundleParentRow() {
    const style = document.createElement('style');
    style.textContent = `
      .cart__item:has(a[href*="commercial-epoxy-flooring-systems"]) {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  })();

  /* =====================================
     PILL PRICE LABELS (per gal / per set)
  ===================================== */

  document.addEventListener('DOMContentLoaded', function () {
    const PER_GAL = ['WB Epoxy Primer', 'Premera FP1 Fusion Primer'];
    const PER_SET = ['Moisture Vapor Barrier', 'High Wear Urethane Finish'];

    document.querySelectorAll('.vb-pill').forEach(pill => {
      const title = pill.getAttribute('data-variant-title');
      const priceEl = pill.querySelector('.vb-pill-sub');
      if (!priceEl || !title) return;

      if (PER_GAL.includes(title) && !priceEl.textContent.toLowerCase().includes('per gal')) {
        priceEl.textContent += ' per gal';
      }
      if (PER_SET.includes(title) && !priceEl.textContent.toLowerCase().includes('per set')) {
        priceEl.textContent += ' per set';
      }
    });
  });

  /* =====================================
     FAQ ACCORDION
  ===================================== */

  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.faq-icon');
      const isOpen = answer.style.maxHeight;

      document.querySelectorAll('.faq-answer').forEach(a => (a.style.maxHeight = null));
      document.querySelectorAll('.faq-icon').forEach(i => (i.style.transform = 'rotate(0deg)'));
      document.querySelectorAll('.faq-question').forEach(q => q.classList.remove('active'));

      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        icon.style.transform = 'rotate(180deg)';
        question.classList.add('active');
      }
    });
  });

  /* =====================================
     HOVER TOOLTIPS – PILL BUTTONS
  ===================================== */

  (function () {
    const tooltips = {
      '54540711952687': '1× 1/8" Notched Squeegee\n2× 18" Pro Performance Rollers\n1× Magic Trowel\n1× Heavy-Duty Roller Frame\n1× Cage Mixer\n1× Spiked Shoes\n2× 9" High-Quality Rollers\n1× Chip Brush',
      '54540711985455': '1× 1/8" Notched Squeegee\n4× 18" Pro Performance Rollers\n1× Magic Trowel\n1× 18" Roller Frame\n1× Box Mixer\n2× Spiked Shoes\n2× 9" Roller Covers\n1× 9" Roller Frame\n2× Chip Brushes',
      '54540712018223': '1× 1/8" Notched Squeegee\n8× 18" Pro Performance Rollers\n1× Magic Trowel\n2× 18" Roller Frames\n2× Box Mixers\n3× Spiked Shoes\n4× 9" Roller Covers\n1× 9" Roller Frame\n4× Chip Brushes',
      '54540623610159': 'Fast curing 100% solids epoxy paste for filling cracks, joints, chips, and divots. Medium gray in color.',
      '54540623642927': 'Fast curing 100% solids epoxy paste for filling cracks and divots on horizontal surfaces. White, can be pigmented.',
      '54540623708463': 'Up to 1000 SF – Blends into the topcoat for light added traction.',
      '53369387155759': 'Fast curing 100% solids epoxy paste for filling cracks, joints, chips, and divots on both horizontal and vertical surfaces. Medium gray in color.',
      '53369488408879': 'Fast curing 100% solids epoxy paste for filling cracks, joints, chips, and divots on horizontal surfaces. Sold white and can be pigmented.',
      '53369488441647': '• 2× 18" Pro Performance Rollers\n• 1× 1/8" Notched Squeegee\n• 2× Heavy-Duty Roller Frame\n• 1× 5-Gallon Cage Mixer\n• 2× Spiked Shoes\n• 2× 9" High-Quality Rollers\n• 1× 9" Roller Frame\n• 2× Chip Brushes',
      '53369387188527': 'Up to 1000 SF – Blend or broadcast into the topcoat to provide light added traction where a modest increase in added slip resistance is wanted.',
      '53369488507183': 'Up to 500 SF – Blend or broadcast into the topcoat to provide aggressive slip resistance. Makes mopping very difficult.',
      '54332602220847': '• 1× 8-12 Mil Notched Squeegee\n• 1× 18" Roller Cover\n• 1× 18" Roller Frame\n• 1× 9" Roller Cover\n• 1× Box Mixer\n• 1× Chip Brush'
    };

    const box = document.createElement('div');
    box.id = 'vb-hover-tooltip';
    box.style.cssText = [
      'display:none', 'position:fixed', 'background:#097CFF', 'color:#fff',
      'padding:14px 18px', 'border-radius:10px', 'font-size:14px', 'line-height:1.6',
      'white-space:pre-wrap', 'z-index:99999', 'width:90vw', 'max-width:360px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.3)', 'pointer-events:none', 'font-family:inherit'
    ].join(';');
    document.body.appendChild(box);

    const mobileBox = document.createElement('div');
    mobileBox.style.cssText = [
      'display:none', 'position:fixed', 'background:#097CFF', 'color:#fff',
      'padding:14px 18px', 'border-radius:10px', 'font-size:14px', 'line-height:1.6',
      'white-space:pre-wrap', 'z-index:99999', 'width:90vw', 'max-width:360px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.3)', 'pointer-events:none', 'font-family:inherit'
    ].join(';');
    document.body.appendChild(mobileBox);

    document.addEventListener('keydown', e => { if (e.key === 'Escape') mobileBox.style.display = 'none'; });
    document.addEventListener('click', e => {
      if (!e.target.closest('.vb-grid-picker_Bq4dpD, .vb-grid-picker_a4Vwmb, .vb-grid-picker_4ydyjy')) {
        mobileBox.style.display = 'none';
      }
    });

    const isTouch = () => navigator.maxTouchPoints > 0 || 'ontouchstart' in window;

    function showDesktopTooltip(text, btn) {
      box.textContent = text;
      box.style.display = 'block';
      const r = btn.getBoundingClientRect();
      let left = r.left + r.width / 2 - 180;
      left = Math.max(10, Math.min(left, window.innerWidth - 370));
      box.style.left = left + 'px';
      box.style.top = (r.bottom + 8) + 'px';
    }

    function showMobileTooltip(text, btn) {
      mobileBox.textContent = text;
      if (mobileBox.parentElement !== document.body) document.body.appendChild(mobileBox);
      const w = Math.min(340, window.innerWidth - 24);
      const r = btn.getBoundingClientRect();
      mobileBox.style.cssText += `;position:absolute;width:${w}px;left:${Math.round((window.innerWidth - w) / 2)}px;top:${window.scrollY + r.bottom + 10}px;display:block;`;
    }

    function attachTooltips() {
      const selector = '.vb-grid-picker_Bq4dpD button.lazyElement.vb-pill, .vb-grid-picker_a4Vwmb button.lazyElement.vb-pill, .vb-grid-picker_4ydyjy button.lazyElement.vb-pill, .vb-grid-picker_VCRcTp button.lazyElement.vb-pill';
      document.querySelectorAll(selector).forEach(btn => {
        const id = btn.getAttribute('data-variant-id');
        if (!id || !tooltips[id] || btn.dataset.vbTooltipReady) return;
        btn.dataset.vbTooltipReady = '1';

        if (!btn.querySelector('.vb-info-icon')) {
          const icon = document.createElement('span');
          icon.className = 'vb-info-icon';
          icon.textContent = ' ⓘ';
          icon.style.cssText = 'font-size:14px;cursor:help;pointer-events:none;';
          btn.appendChild(icon);
        }

        btn.addEventListener('mouseenter', () => { if (!isTouch()) showDesktopTooltip(tooltips[id], btn); });
        btn.addEventListener('mouseleave', () => { if (!isTouch()) box.style.display = 'none'; });
        if (isTouch()) btn.addEventListener('click', () => showMobileTooltip(tooltips[id], btn));
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachTooltips);
    else attachTooltips();
    new MutationObserver(attachTooltips).observe(document.body, { childList: true, subtree: true });
  })();

  /* =====================================
     COLLAPSIBLE SQ FT BLOCK
  ===================================== */

  (function initSqftInput() {
    function setup() {
      const block = document.querySelector('.vb-block[data-key="king"]');
      if (!block || block.dataset.sqftInputReady) return;
      block.dataset.sqftInputReady = '1';

      const grid = block.querySelector('.vb-grid');
      if (!grid) return;

      grid.style.setProperty('display', 'none', 'important');

      const head = block.querySelector('.vb-block-head');
      if (head) head.style.display = 'none';

      const wrapper = document.createElement('div');
      wrapper.className = 'kit-sqft-input-wrap';
      wrapper.innerHTML = `
        <div class="kit-sqft-input-label">Step 2 \u2013 Enter Your Floor Size</div>
        <div class="kit-sqft-input-row">
          <input
            type="number"
            id="kit-sqft-input"
            class="kit-sqft-input"
            placeholder="e.g. 500"
            min="1"
            max="10000"
            autocomplete="off"
            style="width: 132px;"
          />
          <span class="kit-sqft-input-unit">sq ft</span>
        </div>
        <div id="kit-sqft-feedback" class="kit-sqft-feedback"></div>
      `;
      block.insertBefore(wrapper, grid);

      if (!document.getElementById('kit-sqft-input-style')) {
        const style = document.createElement('style');
        style.id = 'kit-sqft-input-style';
        style.textContent = `
          .kit-sqft-input-wrap { padding: 10px 0 20px; }
          .kit-sqft-input-label {
            font-weight: 700; font-size: 20px;
            font-family: 'Nunito', sans-serif; margin-bottom: 12px;
          }
          .kit-sqft-input-row { display: flex; align-items: center; gap: 10px; max-width: 280px; }
          .kit-sqft-input {
            flex: 1; padding: 10px 14px; font-size: 16px;
            border: 2px solid #d1d5db; border-radius: 8px;
            outline: none; font-family: inherit; transition: border-color 0.2s;
            -moz-appearance: textfield;
          }
          .kit-sqft-input::-webkit-outer-spin-button,
          .kit-sqft-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
          .kit-sqft-input:focus {
            border-color: #097CFF;
            box-shadow: 0 0 0 3px rgba(9,124,255,0.12);
          }
          .kit-sqft-input-unit { font-size: 15px; color: #555; font-weight: 600; white-space: nowrap; }
          .kit-sqft-feedback { margin-top: 8px; font-size: 14px; min-height: 20px; font-weight: 500; line-height: 1.4; }
          .kit-sqft-feedback.success { color: #097CFF; }
          .kit-sqft-feedback.error   { color: #c00; }
          @media (min-width: 768px) {
            .kit-sqft-input-wrap { display: flex; flex-wrap: wrap; align-items: center; gap: 0 20px; }
            .kit-sqft-input-label { margin-bottom: 0; white-space: nowrap; flex-shrink: 0; }
            .kit-sqft-input-row { flex-shrink: 0; }
            #kit-sqft-feedback { width: 100%; }
          }
          .vb-block-title .vb-required { display: none !important; }
          .vb-grid-picker_4ydyjy { grid-template-columns: repeat(3, 1fr) !important; }
          .vb-bullets .vb-info-icon { display: none !important; }
        `;
        document.head.appendChild(style);
      }

      function findPillForSqft(sqft) {
        const pills = Array.from(grid.querySelectorAll('.vb-pill'));
        const scored = pills
          .map(function(pill) {
            const title = pill.getAttribute('data-variant-title') || '';
            const clean = title.replace(/,/g, '').replace(/\s+/g, ' ').toLowerCase();
            const m = clean.match(/(\d+)\s*[-–]\s*(\d+)\s*sqft/);
            if (!m) { const m2 = clean.match(/(\d+)\s*sqft/); if (!m2) return null; return { pill: pill, max: parseInt(m2[1], 10) }; }
            return { pill: pill, max: parseInt(m[2], 10) };
          })
          .filter(Boolean)
          .sort(function(a, b) { return a.max - b.max; });
        const match = scored.find(function(item) { return sqft <= item.max; });
        return match ? match.pill : (scored.length ? scored[scored.length - 1].pill : null);
      }

      function applyPillSelection(pill) {
        grid.querySelectorAll('.vb-pill').forEach(function(p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');

        const title = pill.getAttribute('data-variant-title') || '';
        const clean = title.replace(/,/g, '').replace(/\s+/g, ' ').toLowerCase();
        const m = clean.match(/(\d+)\s*[-–]\s*(\d+)\s*sqft/);
        const cents = Number(pill.getAttribute('data-price') || 0);

        window.__METALLIC_KIT_STATE__.sqft = {
          label: title.trim(),
          min:   m ? parseInt(m[1], 10) : 0,
          max:   m ? parseInt(m[2], 10) : 0
        };
        window.__METALLIC_KIT_STATE__.sqftPrice = cents / 100;
        window.__METALLIC_KIT_STATE__.toolkit = null;
        window.__METALLIC_KIT_STATE__.toolkitPrice = 0;

        recalcTotal();
        if (typeof window.__updateTopCoatQtyChips === 'function') window.__updateTopCoatQtyChips();
        if (typeof window.__updateOdorBlockQtyChip === 'function') window.__updateOdorBlockQtyChip();
        if (typeof updateEasyMVBQtyChip === 'function') updateEasyMVBQtyChip();
      }

      var firstPill = grid.querySelector('.vb-pill');
      if (firstPill && !firstPill.classList.contains('is-active')) {
        applyPillSelection(firstPill);
      }

      const input    = document.getElementById('kit-sqft-input');
      const feedback = document.getElementById('kit-sqft-feedback');
      let   _debounce = null;

      input.addEventListener('keydown', function(e) {
        if (['e', 'E', '+', '-', '.'].includes(e.key)) e.preventDefault();
      });

      input.addEventListener('input', function() {
        clearTimeout(_debounce);
        _debounce = setTimeout(function() {
          const raw = parseInt(input.value, 10);
          feedback.className = 'kit-sqft-feedback';
          feedback.textContent = '';

          if (!input.value.trim() || isNaN(raw)) {
            window.__METALLIC_KIT_STATE__.sqft = null;
            window.__METALLIC_KIT_STATE__.sqftPrice = 0;
            recalcTotal();
            return;
          }
          if (raw < 1) {
            feedback.className = 'kit-sqft-feedback error';
            feedback.textContent = 'Please enter a valid square footage greater than 0.';
            return;
          }
          if (raw > 10000) {
            feedback.className = 'kit-sqft-feedback error';
            feedback.textContent = 'Maximum supported size is 10,000 sq ft. Please contact us for larger projects.';
            return;
          }
          const pill = findPillForSqft(raw);
          if (!pill) {
            feedback.className = 'kit-sqft-feedback error';
            feedback.textContent = 'Could not match a range. Please try a different value.';
            return;
          }
          applyPillSelection(pill);
          feedback.className = 'kit-sqft-feedback success';
          feedback.textContent = '\u2713 Kit sized for: ' + (pill.getAttribute('data-variant-title') || '');
        }, 400);
      });
    }

    setTimeout(setup, 300);
    setTimeout(setup, 800);
    document.addEventListener('DOMContentLoaded', setup);
  })();

  /* =====================================
     MVB BLOCK — DYNAMIC QTY CHIPS
  ===================================== */

  (function initMVBQtyChips() {
    const MVB_UPGRADE_KEYS = {
      '58052359192879': 'wb_epoxy_primer',
      '58052359225647': 'moisture_vapor_barrier',
      '58052359258415': 'premera_fp_fusion_primer'
    };

    function updateMVBQtyChips() {
      const state = window.__METALLIC_KIT_STATE__;
      const sqftMax = state?.sqft?.max;
      const block = document.querySelector('.vb-block[data-key="mvb"]');
      if (!block) return;

      block.querySelectorAll('.vb-bullet input[type="radio"]').forEach(input => {
        const domId = input.getAttribute('data-variant-id');
        const upgradeKey = MVB_UPGRADE_KEYS[domId];
        if (!upgradeKey) return;

        const label = input.closest('label');
        if (!label) return;
        const labelSpan = label.querySelector('.vb-bullet-label');
        if (!labelSpan) return;

        const existingChip = labelSpan.querySelector('.vb-qtychip');
        if (existingChip) existingChip.remove();
        if (!sqftMax) return;

        const qty = getUpgradeQtyForSqft(upgradeKey, sqftMax);
        const pricePerUnit = Number(input.getAttribute('data-price') || 0) / 100;
        const total = (pricePerUnit * qty).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        const chip = document.createElement('small');
        chip.className = 'vb-qtychip';
        chip.textContent = ` Qty: ${qty} (+US$${total})`;
        labelSpan.appendChild(chip);
      });

      updateEasyMVBQtyChip();
    }

    setTimeout(updateMVBQtyChips, 500);
    document.addEventListener('vb:changed', () => setTimeout(updateMVBQtyChips, 150));
    document.addEventListener('click', () => setTimeout(updateMVBQtyChips, 150));
  })();

  function updateEasyMVBQtyChip() {
    const block = document.querySelector('.vb .vb-block[data-key="mvb"]');
    if (!block) return;
    const state = window.__METALLIC_KIT_STATE__;
    const sqftMax = state?.sqft?.max;
    const easyInput = block.querySelector('input[data-variant-id="58052359291183"]');
    if (!easyInput) return;
    const label = easyInput.closest('.vb-bullet');
    if (!label) return;
    const labelSpan = label.querySelector('.vb-bullet-label');
    if (!labelSpan) return;
    const existing = labelSpan.querySelector('.vb-qtychip');
    if (existing) existing.remove();
    if (!sqftMax) return;
    const qty = getUpgradeQtyForSqft('premera_easymvb', sqftMax);
    const pricePerUnit = Number(easyInput.getAttribute('data-price') || 0) / 100;
    const total = (pricePerUnit * qty).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const chip = document.createElement('small');
    chip.className = 'vb-qtychip';
    chip.textContent = ` Qty: ${qty} (+US$${total})`;
    labelSpan.appendChild(chip);
  }

  setTimeout(updateEasyMVBQtyChip, 600);
  setTimeout(updateEasyMVBQtyChip, 1400);
  document.addEventListener('vb:changed', () => setTimeout(updateEasyMVBQtyChip, 150));
  document.addEventListener('click', () => setTimeout(updateEasyMVBQtyChip, 150));

  /* =====================================
     TOPCOAT BLOCK — DYNAMIC QTY CHIPS
  ===================================== */

  (function initTopCoatQtyChips() {
    const TOPCOAT_UPGRADE_KEYS = {
      '56460946407727': 'urethane_satin',
      '56460946473263': 'urethane_gloss',
      '56460946538799': 'aqualab',
      '56460946604335': 'labfender',
      '56460946669871': 'polygloss',
      '56460946735407': 'premera_t2'
    };

    function updateTopCoatQtyChips() {
      const state = window.__METALLIC_KIT_STATE__;
      const sqftMax = state?.sqft?.max;
      const block = document.querySelector('.vb-block[data-key="topcoat"]');
      if (!block) return;

      block.querySelectorAll('.vb-bullet input[type="radio"]').forEach(input => {
        const domId = input.getAttribute('data-variant-id');
        const upgradeKey = TOPCOAT_UPGRADE_KEYS[domId];
        if (!upgradeKey) return;
        const label = input.closest('label');
        if (!label) return;
        const labelSpan = label.querySelector('.vb-bullet-label');
        if (!labelSpan) return;

        const existingChip = labelSpan.querySelector('.vb-qtychip');
        if (existingChip) existingChip.remove();
        if (!sqftMax) return;

        const qty = getUpgradeQtyForSqft(upgradeKey, sqftMax);
        const pricePerUnit = Number(input.getAttribute('data-price') || 0) / 100;
        let displayTotal = (pricePerUnit * qty).toFixed(2);
        if (upgradeKey === 'polygloss') {
          displayTotal = calcPolyGlossCost(qty, pricePerUnit).toFixed(2);
        }
        displayTotal = displayTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        const chip = document.createElement('small');
        chip.className = 'vb-qtychip';
        chip.textContent = ` Qty: ${qty} (+US$${displayTotal})`;
        labelSpan.appendChild(chip);
      });

      updateOdorBlockQtyChip();
    }

    window.__updateTopCoatQtyChips = updateTopCoatQtyChips;

    setTimeout(updateTopCoatQtyChips, 500);
    setTimeout(updateTopCoatQtyChips, 1200);
    document.addEventListener('vb:changed', () => setTimeout(updateTopCoatQtyChips, 150));
    document.addEventListener('click', () => setTimeout(updateTopCoatQtyChips, 150));
  })();

  function updateOdorBlockQtyChip() {
    const block = document.querySelector('.vb .vb-block[data-key="topcoat"]');
    if (!block) return;
    const state = window.__METALLIC_KIT_STATE__;
    const sqftMax = state?.sqft?.max;
    const odorInput = block.querySelector('input[data-variant-id="56460946800943"]');
    if (!odorInput) return;
    const label = odorInput.closest('.vb-bullet');
    if (!label) return;
    const labelSpan = label.querySelector('.vb-bullet-label');
    if (!labelSpan) return;
    const existing = labelSpan.querySelector('.vb-qtychip');
    if (existing) existing.remove();
    if (!sqftMax) return;
    const qty = getUpgradeQtyForSqft('premera_t2', sqftMax);
    const pricePerUnit = Number(odorInput.getAttribute('data-price') || 0) / 100;
    const total = (pricePerUnit * qty).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const chip = document.createElement('small');
    chip.className = 'vb-qtychip';
    chip.textContent = ` Qty: ${qty} (+US$${total})`;
    labelSpan.appendChild(chip);
  }

  window.__updateOdorBlockQtyChip = updateOdorBlockQtyChip;
  setTimeout(updateOdorBlockQtyChip, 600);
  setTimeout(updateOdorBlockQtyChip, 1400);
  document.addEventListener('vb:changed', () => setTimeout(updateOdorBlockQtyChip, 150));
  document.addEventListener('click', () => setTimeout(updateOdorBlockQtyChip, 150));

  /* =====================================
     MVB — EASYMVB DEPENDENCY
     EasyMVB only when Premera Fusion Primer selected
  ===================================== */

  (function initEasyMVBDependency() {
    if (!document.getElementById('commercial-easymvb-dep-css')) {
      const style = document.createElement('style');
      style.id = 'commercial-easymvb-dep-css';
      style.textContent = `
        #commercial-easymvb-overlay { position:absolute; inset:0; z-index:10; cursor:not-allowed; display:block; }
        #commercial-easymvb-error-msg {
          display:none; color:#c00; font-size:13px; margin-top:6px; margin-bottom:2px;
          padding:8px 12px; background:#fff0f0; border:1px solid #fcc; border-radius:6px; line-height:1.5;
        }
        .vb-bullet--easymvb-locked { opacity:0.45; }
        .vb-bullet--fusion-pinned { outline:2px solid #2563eb22; border-radius:4px; }
      `;
      document.head.appendChild(style);
    }

    function getMVBBlock() { return document.querySelector('.vb .vb-block[data-key="mvb"]'); }
    function getEasyInput(b) { return b ? b.querySelector('input[data-variant-id="58052359291183"]') : null; }
    function getFusionInput(b) { return b ? b.querySelector('input[data-variant-id="58052359258415"]') : null; }
    function isFusionChecked(b) {
      const c = b ? b.querySelector('input[type="radio"]:checked') : null;
      return c && c.getAttribute('data-variant-id') === '58052359258415';
    }

    function ensureErrorMsg(block) {
      if (!block || document.getElementById('commercial-easymvb-error-msg')) return;
      const msg = document.createElement('p');
      msg.id = 'commercial-easymvb-error-msg';
      msg.textContent = 'Premera EasyMVB can only be added alongside Premera Fusion Primer. Please select Premera Fusion Primer first.';
      const bullets = block.querySelector('.vb-bullets');
      if (bullets) bullets.after(msg);
    }

    function syncState(block) {
      if (!block) return;
      const easyInput = getEasyInput(block);
      const active = isFusionChecked(block) || window.__METALLIC_KIT_STATE__.easyMVBSelected;
      const easyLabel = easyInput ? easyInput.closest('.vb-bullet') : null;
      if (easyLabel) easyLabel.classList.toggle('vb-bullet--easymvb-locked', !active);
      const overlay = document.getElementById('commercial-easymvb-overlay');
      if (overlay) overlay.style.display = active ? 'none' : 'block';
      if (active) { const e = document.getElementById('commercial-easymvb-error-msg'); if (e) e.style.display = 'none'; }
      const fusionLabel = getFusionInput(block)?.closest('.vb-bullet');
      if (fusionLabel) fusionLabel.classList.toggle('vb-bullet--fusion-pinned', !!window.__METALLIC_KIT_STATE__.easyMVBSelected);
      if (easyInput) easyInput.checked = !!window.__METALLIC_KIT_STATE__.easyMVBSelected;
    }

    function setup() {
      const block = getMVBBlock();
      if (!block || block.dataset.easyMVBDepReady) return;
      block.dataset.easyMVBDepReady = '1';

      const easyRaw = block.querySelector('input[data-variant-id="58052359291183"]');
      if (easyRaw && easyRaw.type === 'radio') {
        easyRaw.type = 'checkbox';
        easyRaw.name = 'vb-easymvb-commercial-standalone';
        console.log('✅ Commercial EasyMVB detached from radio group');
      }

      ensureErrorMsg(block);

      const easyLabel = block.querySelector('input[data-variant-id="58052359291183"]')?.closest('.vb-bullet');
      if (easyLabel && !document.getElementById('commercial-easymvb-overlay')) {
        easyLabel.style.position = 'relative';
        const overlay = document.createElement('div');
        overlay.id = 'commercial-easymvb-overlay';
        overlay.addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const msg = document.getElementById('commercial-easymvb-error-msg');
          if (msg) { msg.style.display = 'block'; msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        });
        easyLabel.appendChild(overlay);
      }

      syncState(block);

      const easyInput = getEasyInput(block);
      if (easyInput) {
        easyInput.addEventListener('change', function () {
          window.__METALLIC_KIT_STATE__.easyMVBSelected = this.checked;
          if (this.checked) {
            const fi = getFusionInput(block);
            if (fi && !fi.checked) { fi.checked = true; fi.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          syncState(block);
          recalcTotal();
          updateEasyMVBQtyChip();
        });
      }

      block.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        if (e.target.getAttribute('data-variant-id') !== '58052359258415') {
          window.__METALLIC_KIT_STATE__.easyMVBSelected = false;
          const ei = getEasyInput(block);
          if (ei) ei.checked = false;
        }
        setTimeout(() => { syncState(block); recalcTotal(); updateEasyMVBQtyChip(); }, 20);
      });
    }

    setTimeout(setup, 400);
    setTimeout(setup, 1000);
    setTimeout(setup, 2000);
    document.addEventListener('DOMContentLoaded', setup);
    document.addEventListener('booster:content:update', setup);
  })();

  /* =====================================
     TOPCOAT — ODOR BLOCK DEPENDENCY
     Odor Block only when Premera T-2 selected
  ===================================== */

  (function initOdorBlockDependency() {
    const PREMERA_T2_ID  = '56460946735407';
    const ODOR_BLOCK_ID  = '56460946800943';

    if (!document.getElementById('commercial-odorblock-dep-css')) {
      const style = document.createElement('style');
      style.id = 'commercial-odorblock-dep-css';
      style.textContent = `
        #commercial-odorblock-overlay { position:absolute; inset:0; z-index:10; cursor:not-allowed; display:block; }
        #commercial-odorblock-error-msg {
          display:none; color:#c00; font-size:13px; margin-top:6px; margin-bottom:2px;
          padding:8px 12px; background:#fff0f0; border:1px solid #fcc; border-radius:6px; line-height:1.5;
        }
        .vb-bullet--odorblock-locked { opacity:0.45; }
        .vb-bullet--t2-pinned { outline:2px solid #2563eb22; border-radius:4px; }
      `;
      document.head.appendChild(style);
    }

    function getTopCoatBlock() { return document.querySelector('.vb .vb-block[data-key="topcoat"]'); }
    function getOdorInput(b)   { return b ? b.querySelector(`input[data-variant-id="${ODOR_BLOCK_ID}"]`) : null; }
    function getT2Input(b)     { return b ? b.querySelector(`input[data-variant-id="${PREMERA_T2_ID}"]`) : null; }
    function isT2Checked(b) {
      const c = b ? b.querySelector('input[type="radio"]:checked') : null;
      return c && c.getAttribute('data-variant-id') === PREMERA_T2_ID;
    }

    function ensureErrorMsg(block) {
      if (!block || document.getElementById('commercial-odorblock-error-msg')) return;
      const msg = document.createElement('p');
      msg.id = 'commercial-odorblock-error-msg';
      msg.textContent = 'Odor Block by Premera can only be added alongside Premera T-2 Topcoat Gloss. Please select Premera T-2 Topcoat Gloss first.';
      const bullets = block.querySelector('.vb-bullets');
      if (bullets) bullets.after(msg);
    }

    function syncState(block) {
      if (!block) return;
      const odorInput = getOdorInput(block);
      const active = isT2Checked(block) || window.__METALLIC_KIT_STATE__.odorBlockSelected;
      const odorLabel = odorInput?.closest('.vb-bullet');
      if (odorLabel) odorLabel.classList.toggle('vb-bullet--odorblock-locked', !active);
      const overlay = document.getElementById('commercial-odorblock-overlay');
      if (overlay) overlay.style.display = active ? 'none' : 'block';
      if (active) { const e = document.getElementById('commercial-odorblock-error-msg'); if (e) e.style.display = 'none'; }
      const t2Label = getT2Input(block)?.closest('.vb-bullet');
      if (t2Label) t2Label.classList.toggle('vb-bullet--t2-pinned', !!window.__METALLIC_KIT_STATE__.odorBlockSelected);
      if (odorInput) odorInput.checked = !!window.__METALLIC_KIT_STATE__.odorBlockSelected;
    }

    function setup() {
      const block = getTopCoatBlock();
      if (!block || block.dataset.odorBlockDepReady) return;
      block.dataset.odorBlockDepReady = '1';

      const odorRaw = block.querySelector(`input[data-variant-id="${ODOR_BLOCK_ID}"]`);
      if (odorRaw && odorRaw.type === 'radio') {
        odorRaw.type = 'checkbox';
        odorRaw.name = 'vb-odorblock-commercial-standalone';
        console.log('✅ Commercial Odor Block detached from radio group');
      }

      ensureErrorMsg(block);

      const odorLabel = block.querySelector(`input[data-variant-id="${ODOR_BLOCK_ID}"]`)?.closest('.vb-bullet');
      if (odorLabel && !document.getElementById('commercial-odorblock-overlay')) {
        odorLabel.style.position = 'relative';
        const overlay = document.createElement('div');
        overlay.id = 'commercial-odorblock-overlay';
        overlay.addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const msg = document.getElementById('commercial-odorblock-error-msg');
          if (msg) { msg.style.display = 'block'; msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        });
        odorLabel.appendChild(overlay);
      }

      syncState(block);

      const odorInput = getOdorInput(block);
      if (odorInput) {
        odorInput.addEventListener('change', function () {
          window.__METALLIC_KIT_STATE__.odorBlockSelected = this.checked;
          if (this.checked) {
            const t2 = getT2Input(block);
            if (t2 && !t2.checked) { t2.checked = true; t2.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          syncState(block);
          recalcTotal();
          updateOdorBlockQtyChip();
        });
      }

      block.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        if (e.target.getAttribute('data-variant-id') !== PREMERA_T2_ID) {
          window.__METALLIC_KIT_STATE__.odorBlockSelected = false;
          const oi = getOdorInput(block);
          if (oi) oi.checked = false;
        }
        setTimeout(() => { syncState(block); recalcTotal(); updateOdorBlockQtyChip(); }, 20);
      });
    }

    setTimeout(setup, 400);
    setTimeout(setup, 1000);
    setTimeout(setup, 2000);
    document.addEventListener('DOMContentLoaded', setup);
    document.addEventListener('booster:content:update', setup);
  })();

  /* =====================================
     PRIMER + TOPCOAT – INLINE RADIO TOOLTIPS
  ===================================== */

  (function () {
    const RADIO_TOOLTIPS = {
      'epoxy primer wb':  'Seals the concrete and increases adhesion so your coatings bond properly. Recommended for stronger, longer lasting floors. Needed for wood substrate and porous or soft concrete.',
      'fusion primer':    'Premera FP1 Fusion Primer eliminates concrete grinding. This cutting edge, fast drying spray on primer is designed to bond any resinous material seamlessly to nearly any smooth, hard, contaminate free surface.',
      'moisture vapor':   'A 100% solids epoxy made to block moisture from rising up through the concrete and delaminating the epoxy in high moisture areas such as basements and exterior surfaces.',
      'easymvb':          'Penetrating moisture vapor barrier that soaks into concrete and seals it from within. Designed for use only with Premera Fusion Primer, EasyMVB blocks up to 25 lbs of moisture vapor transmission while sealing pores and capillaries inside the concrete.',
      'urethane satin':   'One Stop Epoxy Urethane Satin provides a durable, low gloss urethane topcoat with a natural orange peel texture. Strong chemical and abrasion resistance. Low odor profile.',
      'urethane gloss':   'One Stop Epoxy Urethane Gloss is a medium gloss urethane topcoat delivering strong chemical resistance and dependable durability. Low odor profile.',
      'aqualab':          'LabSurface AquaLab Urethane Pure Gloss offers a brighter, higher gloss than standard urethanes with strong chemical and abrasion resistance. Slightly higher skill level required.',
      'labfender':        'LabFender Polyurethane is a three part, high wear urethane with aluminum oxide for added strength and durability. Recommended for experienced installers only.',
      'polygloss':        'PolyGloss Slow Go is a very user friendly polyaspartic that installs easily and levels to a smooth, consistent gloss. High VOC – use a respirator and ventilate the area.',
      'premera t-2':      'Premera T2 is a high gloss, ultra abrasion resistant topcoat that lays down a glass-like finish. Very hard and durable. High VOC, strong odor. Best for very experienced installers.',
      'odor block':       'A penetrating odor-blocking additive for use only with Premera T-2 Topcoat Gloss. Suppresses solvent odors during application and cure.'
    };

    function getTooltipText(title) {
      const t = title.toLowerCase();
      if (t.includes('easymvb')) return RADIO_TOOLTIPS['easymvb'];
      if (t.includes('odor block')) return RADIO_TOOLTIPS['odor block'];
      for (const [key, text] of Object.entries(RADIO_TOOLTIPS)) {
        if (key === 'easymvb' || key === 'odor block') continue;
        if (t.includes(key)) return text;
      }
      return null;
    }

    const tip = document.createElement('div');
    tip.id = 'commercial-radio-tooltip';
    tip.style.cssText = [
      'display:none', 'position:fixed', 'background:#097CFF', 'color:#fff',
      'padding:12px 16px', 'border-radius:10px', 'font-size:13px', 'line-height:1.6',
      'white-space:pre-wrap', 'z-index:99999', 'width:280px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.3)', 'pointer-events:none', 'font-family:inherit'
    ].join(';');
    document.body.appendChild(tip);

    const isTouch = () => navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
    let tipShownAt = 0;

    function positionTip(el) {
      const r = el.getBoundingClientRect();
      if (window.innerWidth <= 1024) {
        tip.style.position = 'absolute';
        tip.style.width = Math.min(280, window.innerWidth - 20) + 'px';
        const rowEl = el.closest('.vb-bullet') || el;
        if (tip.parentElement !== rowEl) { rowEl.style.position = 'relative'; rowEl.appendChild(tip); }
        tip.style.top = (rowEl.offsetHeight + 8) + 'px';
        tip.style.left = '0px';
      } else {
        tip.style.position = 'fixed';
        tip.style.width = '280px';
        let left = r.right + 20;
        let top  = r.top + r.height / 2 - 30;
        if (left + 290 > window.innerWidth) left = r.left - 290 - 20;
        left = Math.max(10, left);
        top  = Math.max(10, Math.min(top, window.innerHeight - 200));
        tip.style.left = left + 'px';
        tip.style.top  = top  + 'px';
        if (tip.parentElement !== document.body) document.body.appendChild(tip);
      }
    }

    // Suppress VB framework's own native tooltip popups on topcoat/MVB blocks
    // so only our custom blue tooltip fires (no gray/dark duplicates)
    (function suppressVBNativeTooltips() {
      if (document.getElementById('commercial-suppress-vb-tips')) return;
      const s = document.createElement('style');
      s.id = 'commercial-suppress-vb-tips';
      s.textContent = `
        .vb-block[data-key="topcoat"] .vb-pop,
        .vb-block[data-key="topcoat"] .vb-tooltip,
        .vb-block[data-key="topcoat"] .vb-info-box,
        .vb-block[data-key="topcoat"] .vb-bubble,
        .vb-block[data-key="topcoat"] .tippy-box,
        .vb-block[data-key="mvb"] .vb-pop,
        .vb-block[data-key="mvb"] .vb-tooltip,
        .vb-block[data-key="mvb"] .vb-info-box,
        .vb-block[data-key="mvb"] .vb-bubble,
        .vb-block[data-key="mvb"] .tippy-box { display: none !important; }
      `;
      document.head.appendChild(s);
    })();

    function attach() {
      const SELECTORS = [
        '.vb-block[data-key="mvb"] input[type="radio"]',
        '.vb-block[data-key="mvb"] input[type="checkbox"]',
        '.vb-block[data-key="topcoat"] input[type="radio"]',
        '.vb-block[data-key="topcoat"] input[type="checkbox"]'
      ];

      document.querySelectorAll(SELECTORS.join(', ')).forEach(input => {
        if (input.dataset.commTipReady) return;
        input.dataset.commTipReady = '1';
        const title = input.getAttribute('data-variant-title') || '';
        const text = getTooltipText(title);
        if (!text) return;
        const label = input.closest('.vb-bullet');
        if (!label) return;
        const labelSpan = label.querySelector('.vb-bullet-label');
        if (!labelSpan) return;
        // Guard on the span itself — prevents a second listener if VB framework
        // recreates the <input> element (clearing its dataset) but keeps the same span
        if (labelSpan.dataset.commTipSpanReady) return;
        labelSpan.dataset.commTipSpanReady = '1';
        labelSpan.style.display = 'inline';
        labelSpan.style.cursor  = 'default';

        labelSpan.addEventListener('mouseenter', e => {
          if (isTouch()) return;
          e.stopPropagation(); // prevent VB framework tooltip from also firing
          tip.textContent = text; tip.style.display = 'block'; positionTip(labelSpan);
        });
        labelSpan.addEventListener('mouseleave', e => {
          if (!isTouch()) { e.stopPropagation(); tip.style.display = 'none'; }
        });
        labelSpan.addEventListener('click', e => {
          if (!isTouch()) return;
          e.stopPropagation();
          const uid = Math.random().toString(36).slice(2);
          if (tip.style.display === 'block' && tip.dataset.forLabel === labelSpan.dataset.labelId) { tip.style.display = 'none'; return; }
          labelSpan.dataset.labelId = uid;
          tip.dataset.forLabel      = uid;
          tip.textContent = text; tip.style.display = 'block'; positionTip(labelSpan);
          tipShownAt = Date.now();
        });
      });

      // Section title tooltips
      const TITLE_TOOLTIPS = {
        'Primers and Moisture Vapor Barrier': 'Prevent moisture related issues beneath your commercial epoxy floor. A moisture vapor barrier replaces a standard water based epoxy primer and resists up to 25 pounds of osmotic moisture vapor pressure.',
        'Top Coat': 'Select from multiple finish coat options. Hover over each product for details.',
        'Application Products and Tools': 'Includes crack and joint repair pastes and complete tool kits designed for commercial epoxy flooring systems.'
      };

      document.querySelectorAll('.vb-block-title').forEach(titleEl => {
        if (titleEl.dataset.commTipReady) return;
        const rawText = titleEl.textContent.replace(/\s+/g, ' ').trim();
        const titleText = TITLE_TOOLTIPS[rawText];
        if (!titleText) return;
        titleEl.dataset.commTipReady = '1';
        titleEl.style.cursor = 'default';

        titleEl.addEventListener('mouseenter', () => {
          if (isTouch()) return;
          tip.textContent = titleText; tip.style.display = 'block'; positionTip(titleEl);
        });
        titleEl.addEventListener('mouseleave', () => { if (!isTouch()) tip.style.display = 'none'; });
        titleEl.addEventListener('click', e => {
          if (!isTouch()) return;
          e.stopPropagation();
          e.preventDefault();
          if (tip.style.display === 'block' && tip.dataset.forLabel === titleEl.dataset.labelId) { tip.style.display = 'none'; return; }
          const uid = Math.random().toString(36).slice(2);
          titleEl.dataset.labelId = uid;
          tip.dataset.forLabel    = uid;
          tip.textContent = titleText; tip.style.display = 'block'; positionTip(titleEl);
          tipShownAt = Date.now();
        });
      });
    }

    document.addEventListener('click', e => {
      if (Date.now() - tipShownAt < 300) return;
      if (e.target.closest('.vb-bullet-label, .vb-block-title, .vb-swatch-wrap')) return;
      tip.style.display = 'none';
    });

    setTimeout(attach, 600);
    setTimeout(attach, 1400);
    document.addEventListener('DOMContentLoaded', attach);
    document.addEventListener('booster:content:update', attach);

    let _debounce = null;
    new MutationObserver(() => { clearTimeout(_debounce); _debounce = setTimeout(attach, 200); })
      .observe(document.body, { childList: true, subtree: true });
  })();

  /* =====================================
     BASE COLOR SWATCH TOOLTIPS
  ===================================== */

  (function () {
    const SWATCH_TIPS = {
      'White':       'Provides a bright clean finish ideal for labs, showrooms, and medical facilities. DO NOT USE in direct sunlight the floor will eventually amber.',
      'Lite Gray':   'A versatile light gray base suitable for most commercial applications. Neutral and professional.',
      'Medium Gray': 'The most popular commercial base coat. Provides a classic, industrial look suitable for warehouses, garages, and retail floors.',
      'Black':       'Dramatic and bold — makes surface details stand out. Popular for showrooms and high-end commercial spaces.',
      'Tan':         'Warm, earthy tone. Use for tan, beige, or warm-toned floors to keep colors true. Works well with coffee and bronze pigments.',
      'Royal Blue':  'A rich, vibrant blue base ideal for corporate, automotive, and specialty commercial installations.'
    };

    if (!document.getElementById('commercial-swatch-tip-style')) {
      const s = document.createElement('style');
      s.id = 'commercial-swatch-tip-style';
      s.textContent = `
        .vb-swatch-wrap { position: relative; }
        .vb-swatch-tip {
          display: none; position: absolute; top: calc(100% + 16px); left: 50%;
          transform: translateX(-50%);
          width: 220px; max-width: calc(100vw - 24px);
          background: #097CFF;
          border-radius: 10px; box-shadow: 0 6px 20px rgba(0,0,0,.18);
          padding: 10px 12px; font-size: 13px; line-height: 1.5; color: #fff;
          z-index: 99; pointer-events: none; text-align: left;
        }
        .vb-swatch-tip::before {
          content:''; position:absolute; top:-7px; left:50%; transform:translateX(-50%);
          border-width:0 7px 7px; border-style:solid; border-color:transparent transparent #097CFF;
        }
        .vb-swatch-wrap:hover .vb-swatch-tip { display: block; }
        /* First/last swatch: prevent overflow on all screen sizes */
        .vb-swatches .vb-swatch-wrap:first-child .vb-swatch-tip { left: 0 !important; transform: none !important; }
        .vb-swatches .vb-swatch-wrap:last-child  .vb-swatch-tip { left: auto !important; right: 0 !important; transform: none !important; }
        .vb-swatch-wrap .vb-swatch {
          display: flex !important; flex-direction: column !important; align-items: center !important;
          gap: 8px !important; padding: 12px !important; border: 1.5px solid #d7dbe0 !important;
          border-radius: 12px !important; background: #fff !important; cursor: pointer !important;
          width: 100% !important; height: 100% !important; box-sizing: border-box !important;
        }
        .vb-swatch-wrap .vb-swatch.is-active {
          border: 1.5px solid #097CFF !important; background: #f7fbff !important;
        }
        @media (max-width: 1024px) {
          .vb-swatch-tip {
            width: min(200px, 68vw) !important;
            z-index: 99999 !important;
          }
          /* Col 3 & 6 (rightmost in 3-col grid) → pin to right edge */
          .vb-swatches .vb-swatch-wrap:nth-child(3n) .vb-swatch-tip {
            left: auto !important; right: 0 !important; transform: none !important;
          }
          .vb-swatches .vb-swatch-wrap:nth-child(3n) .vb-swatch-tip::before {
            left: auto !important; right: 20px !important; transform: none !important;
          }
          /* Col 1 of row 2 (item 4: Black) → pin to left edge */
          .vb-swatches .vb-swatch-wrap:nth-child(3n+1):not(:first-child) .vb-swatch-tip {
            left: 0 !important; transform: none !important;
          }
          .vb-swatches .vb-swatch-wrap:nth-child(3n+1):not(:first-child) .vb-swatch-tip::before {
            left: 20px !important; transform: none !important;
          }
        }
      `;
      document.head.appendChild(s);
    }

    function attachSwatchTips() {
      document.querySelectorAll('.vb-swatches .vb-swatch').forEach(btn => {
        if (btn.closest('.vb-swatch-wrap')) return; // already wrapped
        const label = btn.getAttribute('data-label') || '';
        const tipText = SWATCH_TIPS[label];
        if (!tipText) return;

        const wrap = document.createElement('div');
        wrap.className = 'vb-swatch-wrap';
        btn.parentNode.insertBefore(wrap, btn);
        wrap.appendChild(btn);

        const tipEl = document.createElement('div');
        tipEl.className = 'vb-swatch-tip';
        tipEl.textContent = tipText;
        wrap.appendChild(tipEl);
      });
    }

    setTimeout(attachSwatchTips, 400);
    setTimeout(attachSwatchTips, 1000);
    document.addEventListener('DOMContentLoaded', attachSwatchTips);
    document.addEventListener('vb:changed', attachSwatchTips);
  })();

  /* =====================================
     CLEAN UP BUNDLE SUMMARY LINE LABELS
  ===================================== */

  (function cleanBundleSummaryLines() {
    let _cartCache = null;
    let _cartCacheTime = 0;

    function rewriteSummaryLines() {
      const now = Date.now();
      const useCache = _cartCache && (now - _cartCacheTime < 10000);
      const cartPromise = useCache
        ? Promise.resolve(_cartCache)
        : fetch('/cart.js?_=' + now).then(r => r.json()).then(cart => {
            _cartCache = cart; _cartCacheTime = Date.now(); return cart;
          }).catch(() => _cartCache);

      if (!cartPromise) return;

      cartPromise.then(cart => {
        if (!cart) return;

        document.querySelectorAll('.cart__bundle-summary').forEach(summary => {
          const bundleRow = summary.closest('[data-bundle-id]');
          if (!bundleRow) return;
          const bundleId = bundleRow.getAttribute('data-bundle-id');
          if (!bundleId || !bundleId.startsWith('commercial-epoxy-')) return;

          const bundleItems = cart.items.filter(i =>
            i.properties && i.properties._bundle_id === bundleId
          );

          summary.querySelectorAll('.cart__bundle-summary-line').forEach(li => {
            const raw = (li.textContent || '').trim();

            if (raw.includes('Commercial Epoxy Flooring System')) {
              li.style.display = 'none';
              return;
            }

            if (/self leveling/i.test(raw)) {
              const epoxyItem = bundleItems.find(i =>
                i.properties && i.properties._bundle_role === 'epoxy-color'
              );
              if (epoxyItem) {
                const color = epoxyItem.variant_title || '';
                li.innerHTML = `<strong>Self Leveling 100% Solids Epoxy – ${epoxyItem.quantity} × ${color}</strong>`;
              }
              return;
            }

            if (/included in kit/i.test(raw)) {
              let name = raw.replace(/\s*-\s*included in kit.*/i, '').trim().replace(/\s*×\s*\d+\s*$/, '').trim();
              const qtyMatch = raw.match(/×\s*(\d+)\s*$/i);
              const qty = qtyMatch ? parseInt(qtyMatch[1]) : 1;
              li.innerHTML = `<strong>${name} – ${qty === 1 ? '1 Unit' : qty + ' Units'}</strong>`;
            }
          });
        });
      });
    }

    setTimeout(rewriteSummaryLines, 100);
    setTimeout(rewriteSummaryLines, 500);
    document.addEventListener('DOMContentLoaded', rewriteSummaryLines);
    document.addEventListener('booster:content:update', rewriteSummaryLines);

    let _timer = null;
    new MutationObserver(mutations => {
      if (!mutations.some(m => Array.from(m.addedNodes).some(n =>
        n.nodeType === 1 && (n.classList?.contains('cart__bundle-summary') || n.querySelector?.('.cart__bundle-summary-list'))
      ))) return;
      clearTimeout(_timer);
      _timer = setTimeout(rewriteSummaryLines, 300);
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* =====================================
     IMAGE CAROUSEL — HEIGHT & PADDING
     Fix: 500px height, 20px top, 50px bottom
  ===================================== */

  (function fixCarouselDimensions() {
    if (!IS_BUILDER_PAGE) return;

    function applyCarouselFix() {
      // Override CSS custom property for height (was 60vh)
      const wrapper = document.querySelector('.image-carousel-wrapper');
      if (wrapper) {
        wrapper.style.setProperty('--carousel-height', '500px');
      }

      // Apply padding to the wrapping shopify-section
      const section = wrapper
        ? wrapper.closest('.shopify-section')
        : null;
      if (section) {
        section.style.paddingTop    = '20px';
        section.style.paddingBottom = '50px';
      }
    }

    // Also inject a CSS rule as a reliable fallback
    if (!document.getElementById('commercial-carousel-fix-css')) {
      const s = document.createElement('style');
      s.id = 'commercial-carousel-fix-css';
      s.textContent = `
        .image-carousel-wrapper { --carousel-height: 500px !important; }
        #shopify-section-template--26384739795247__image_carousel_UVDYJE {
          padding-top: 20px !important;
          padding-bottom: 50px !important;
        }
      `;
      document.head.appendChild(s);
    }

    if (!document.getElementById('commercial-layout-fixes-css')) {
      const s = document.createElement('style');
      s.id = 'commercial-layout-fixes-css';
      s.textContent = `
        @media (max-width: 1024px) {
          main[role="main"] {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }
          /* Exclude hero banner and footer wrapper from the padding */
          #shopify-section-template--26384739795247__section_content_RJWE8z,
          .wrapper--bottom {
            margin-left: -10px !important;
            margin-right: -10px !important;
            width: calc(100% + 20px) !important;
            max-width: none !important;
          }
          /* iPad + mobile: base color swatches 3 columns (2 rows of 6) */
          .vb-swatches {
            grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
          }
        }
      `;
      document.head.appendChild(s);
    }

    applyCarouselFix();
    setTimeout(applyCarouselFix, 300);
    document.addEventListener('DOMContentLoaded', applyCarouselFix);
  })();

// =====================================
// SCROLL TO TOP BUTTON
// =====================================
(function initScrollToTop() {
  if (document.getElementById('kit-scroll-top-btn')) return;

  const style = document.createElement('style');
  style.textContent = `
    #kit-scroll-top-btn {
      position: fixed;
      bottom: 100px;
      right: 100px;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background: #00008C;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.25s ease;
      box-shadow: 0 3px 10px rgba(0,0,0,0.25);
    }
    #kit-scroll-top-btn.is-visible {
      opacity: 1;
      pointer-events: auto;
    }
    #kit-scroll-top-btn svg {
      display: block;
    }
    @media (max-width: 1024px) {
      #kit-scroll-top-btn {
        bottom: 70px;
        right: 70px;
      }
    }
    @media (max-width: 600px) {
      #kit-scroll-top-btn {
        bottom: 30px;
        right: 30px;
        width: 26px;
        height: 26px;
      }
    }
  `;
  document.head.appendChild(style);

  const btn = document.createElement('button');
  btn.id = 'kit-scroll-top-btn';
  btn.setAttribute('aria-label', 'Scroll to top');
  btn.innerHTML = `<svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 10L7 4L12 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  document.body.appendChild(btn);

  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 300);
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// =====================================
// MOBILE — JUMP TO NEXT STEP BUTTON
// =====================================
(function initJumpToNextStep() {
  if (!document.getElementById('kit-jump-next-css')) {
    const style = document.createElement('style');
    style.id = 'kit-jump-next-css';
    style.textContent = `
      #kit-jump-next-btn {
        display: none;
        position: fixed;
        bottom: 28px;
        left: 50%;
        transform: translateX(-50%);
        background: #00008B;
        color: #fff;
        border: none;
        border-radius: 10px;
        padding: 12px 22px;
        font-size: 15px;
        font-weight: 600;
        font-family: inherit;
        cursor: pointer;
        z-index: 99998;
        box-shadow: 0 4px 16px rgba(0,0,139,0.3);
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.25s ease;
        pointer-events: none;
      }
      #kit-jump-next-btn.is-visible {
        display: flex;
        opacity: 1;
        pointer-events: auto;
      }
      @media (min-width: 768px) {
        #kit-jump-next-btn { display: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  const btn = document.createElement('button');
  btn.id = 'kit-jump-next-btn';
  btn.setAttribute('aria-label', 'Jump to next step');
  btn.innerHTML = `Jump to Next Step <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0"><path d="M2 4L7 10L12 4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  document.body.appendChild(btn);

  function isSqftOpen() {
    const grid = document.querySelector('.vb-block[data-key="king"] .vb-grid');
    if (!grid) return false;
    if (grid.style.opacity === '0') return false;
    if (grid.style.maxHeight === '0px' || grid.style.maxHeight === '0') return false;
    return true;
  }

  function checkJumpBtn() {
    if (window.innerWidth >= 768) { btn.classList.remove('is-visible'); return; }
    const sqftBlock = document.querySelector('.vb-block[data-key="king"]');
    if (!sqftBlock || !isSqftOpen()) { btn.classList.remove('is-visible'); return; }
    const rect = sqftBlock.getBoundingClientRect();
    const isInView = rect.top < window.innerHeight / 2 && rect.bottom > 0;
    const isPast   = rect.bottom <= 0;
    let nextEl = sqftBlock.nextElementSibling;
    while (nextEl && nextEl.offsetHeight === 0) nextEl = nextEl.nextElementSibling;
    const nextVisible = nextEl ? nextEl.getBoundingClientRect().top < window.innerHeight : false;
    if (isInView && !isPast && !nextVisible) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
  }

  btn.addEventListener('click', function () {
    const sqftBlock = document.querySelector('.vb-block[data-key="king"]');
    if (!sqftBlock) return;
    let next = sqftBlock.nextElementSibling;
    while (next && next.offsetHeight === 0) next = next.nextElementSibling;
    if (!next) return;
    const headerHeight = document.querySelector('header')?.offsetHeight || 120;
    const top = next.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
    window.scrollTo({ top, behavior: 'smooth' });
    btn.classList.remove('is-visible');
  });

  window.addEventListener('scroll', checkJumpBtn, { passive: true });
  window.addEventListener('resize', checkJumpBtn, { passive: true });

  const sqftGrid = document.querySelector('.vb-block[data-key="king"] .vb-grid');
  if (sqftGrid) {
    new MutationObserver(checkJumpBtn).observe(sqftGrid, { attributes: true, attributeFilter: ['style'] });
  }
})();

})(); 